import React, { Component } from "react";
import { Button, Modal, Breadcrumb } from "react-bootstrap";
import LoadingOverlay from "react-loading-overlay";
import {
  Collapse,
  CardBody,
  Card,
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
  Input,
} from "reactstrap";
import DatePicker from "react-date-picker";
import { connect } from "react-redux";
import $ from "jquery";
import "bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dropzone from "react-dropzone";
import SimpleReactValidator from "simple-react-validator";
import Spinner from "react-bootstrap/Spinner";
import * as moment from "moment";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

toast.configure();
class CreateRequest extends Component {
  constructor(props) {
    super(props);
    this.validator1 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.validator2_1 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.validator2_2 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.validator2_3 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.validator3 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.validator5 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.validator5_2 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.validator6 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.state = {
      content: "",
      step1: "block",
      step2: "none",
      step3: "none",
      step4: "none",
      step5: "none",
      stepbarballon: 1,
      show: false,
      value: new Date(),
      errorStatus: false,
      Referenceno: "",
      workflowid: "",
      sequence_no: "",
      approverEdit: { status: false, value: "" },
      getEmployeeFirstShow: false,
      formGetEmployeeFirstShow: false,
      approverGetEmployeeFirstShow: false,
      getAuthorizedNameSecondShow: false,
      getAuthorizedCompanySecondShow: false,
      goodsItemEdit: false,
      goodsItemdeletePopup: false,
      editAttachments: false,
      editReferences: false,
      GoodsItemAdd: "none",
      RequestlistArray: [],
      ActionTypelistArray: [],
      CompanylistArray: [],
      DivisionListArray: [],
      isLoading: false,
      sectionListArray: [],
      exitOptionList: [],
      StaffDetailslistArray: [],
      formStaffDetailslistArray: [],
      approverStaffDetailslistArray: [],
      companylistArray: [],
      VehiclelistArray: [],
      TypeofGoodslistArray: [],
      ExitPurposelistArray: [],
      AuthCategorylistArray: [],
      ExitTimelistArray: [],
      StatusofGoodslistArray: [],
      GoodsItemslistArray: [],
      AttachmentslistArray: [],
      ReferenceLinkslistArray: [],
      popupEmployeeId: "",
      formPopupEmployeeId: "",
      approverpopupEmployeeId: "",
      popupEmployeeName: "",
      formPopupEmployeeName: "",
      approverpopupEmployeeName: "",
      popupSection: 0,
      formPopupSection: 0,
      approverpopupSection: 0,
      section: "",
      formSection: "",
      approversection: "",
      typeOfExit: "",
      actionType: "",
      employeeID: "",
      positionID: "",
      salaryGrade: "",
      createDescription: "",
      workingGroup: "",
      companyCode: "",
      divisionCode: "",
      addInfo: "",
      dateJoin: "",
      RequesterId: 0,
      formRequesterId: 0,
      approverRequesterId: 0,
      RequesterName: "",
      formRequesterName: "",
      approverRequesterName: "",
      RequesterSection: "",
      formRequesterSection: "",
      approverRequesterSection: "",
      RequesterSectionName: "",
      formRequesterSectionName: "",
      approverRequesterSectionName: "",
      RequesterDepartment: "",
      formRequesterDepartment: "",
      approverRequesterDepartment: "",
      RequesterDivision: "",
      formRequesterDivision: "",
      approverRequesterDivision: "",
      RequesterDesignation: "",
      formRequesterDesignation: "",
      approverRequesterDesignation: "",
      RequesterDisplayName: "",
      formRequesterDisplayName: "",
      approverRequesterDisplayName: "",
      Description: "",
      UserId: this.props.UserId,
      canStafNamePopover: "none",
      formCanStafNamePopover: "none",
      approverCanStafNamePopover: "none",
      address: "",
      Section: "",
      SectionName: "",
      Department: "",
      Division: "",
      Designation: "",
      Authorizedcategory: "MMHE Staff",
      Authorizedid: "",
      Authorizedname: "",
      Icnumber: "",
      Authorizedcompany: "",
      Authorizedcompanyaddress: "",
      Vehiclenumber: "",
      popupCompanyNo: "",
      popupCompanyName: "",
      phoneNumber: "",
      Authorizedcompanyname: "",
      ActionCatrgory: "Single",
      referencelink: "",
      remarks: "",
      Exitpurpose: "",
      GoodsItem_Qtyunit: "",
      GoodsItem_Serialno: "",
      GoodsItem_Description: "",
      GoodsItem_Qtyreturn: "",
      GoodsItem_Edit_Sequenceno: "",
      GoodsItem_Edit_Qtyunit: "",
      GoodsItem_Edit_Serialno: "",
      GoodsItem_Edit_Description: "",
      GoodsItem_Edit_Qtyreturn: "",
      goodsItemdeleteid: "",
      addAttachments_Filename: "",
      addAttachments_Filetype: "",
      addAttachments_URL: "",
      addAttachments_Remarks: "",
      editAttachemnts_Remarks: "",
      editAttachments_Sequenceno: "",
      editAttachments_Filename: "",
      editAttachments_Filetype: "",
      editAttachments_URL: "",
      attachmentdeletePopup: "",
      ReferencesAdd: "none",
      ApproverReferencesAdd: "none",
      attachmentdeleteid: "",
      editReferences_Reflink: "",
      editReferences_Remarks: "",
      editAttachments_Remarks: "",
      editReferences_Sequenceno: "",
      joiningDate: new Date(),
      lastDate: new Date(),
      startDate: new Date(),
      endDate: new Date(),
      Goodsstatus: "",
      showGoodsItemRequired: "none",
      referencesdeletePopup: false,
      ApproverReferencesdeletePopup: false,
      referencesdeleteid: "",
      ApproverReferencesdeleteid: "",
      showAttachedRequired: false,
      showReferenceRequired: "none",
      ApproverShowReferenceRequired: "none",
      isRequesterInformation: "",
      isAuthorizedCarrier: "",
      issaveGoodsCategory: "",
      StaffDetailslistArraySpin: "none",
      formStaffDetailslistArraySpin: "none",
      approverStaffDetailslistArraySpin: "none",
      companylistArraySpin: "none",
      Exitpurposeremarks: "",
      Goodsstatusremarks: "",
      goodsItemLoader: "No",
      AttachmentsLoader: "No",
      ReferencesLoader: "No",
      ApproverReferencesLoader: "No",
      Goodsexittimeremarks: ".",
      companynolistArray: [],
      attachments: [],
      step1: true,
      step2: true,
      step3: false,
      step4: false,
      wordCount: {
        intialValue: 5000,
        count: 0,
      },
    };
  }

  componentDidMount() {
    $("#StafNamePopover").popover({ html: true });
    this.props.dispatch({ type: "headerTitle", value: "Create Request" });
    this.props.dispatch({ type: "Referenceno", value: "" });
    this.getStaffName();
    this.RequestTypeListData(this.props.UserId);
    this.CompanyListData();
    this.SectionListData();
    this.GetActionTypeListData();
    this.GetExitListData();
    this.GetAttachmentslistData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.ActionCatrgory !== this.state.ActionCatrgory) {
      this.GetActionTypeListData();
    }
  }

  getStaffName = () => {
    try {
      let postData = {
        employeeId: this.props.UserId,
        name: this.props.userName,
        section: "",
        employeeType: "All",
      };
      fetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/StaffInfo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            this.setState({
              RequesterId: data.resultObject[0]?.employeeId,
              RequesterName: data.resultObject[0]?.name,
              RequesterSection: data.resultObject[0]?.section,
              RequesterSectionName: data.resultObject[0]?.sectionName,
              RequesterDepartment: data.resultObject[0]?.department,
              RequesterDivision: data.resultObject[0]?.division,
              RequesterDesignation: data.resultObject[0]?.designation,
              RequesterDisplayName:
                data.resultObject[0]?.employeeId +
                " - " +
                data.resultObject[0]?.name,
              canStafNamePopover: "flex",
              joiningDate: data.resultObject[0]?.dateJoin,
            });

            //safik
            if (data.resultObject[0]?.employeeId) {
              this.getStaffDetails(
                data.resultObject[0]?.employeeId,
                data.resultObject[0]?.name,
                data.resultObject[0]?.section,
                data.resultObject[0]?.sectionName,
                data.resultObject[0]?.department,
                data.resultObject[0]?.division,
                data.resultObject[0]?.designation,
                data.resultObject[0]?.dateJoin
              );
            }
          }
        })

        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  RequestTypeListData = (id) => {
    //Rithika
    try {
      let requestType = "requestor";
      let requesterId = id;
      if (id == this.props.UserId) {
        requestType = "requestor";
      } else {
        requestType = "onBehalf";
      }
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/eDocTypeDropdown?UserId=${this.props.UserId}&requestType=${requestType}&requesterId=${requesterId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            this.setState({
              ...this.state,
              RequestlistArray: data?.resultObject,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  CompanyListData = () => {
    try {
      let postData = {
        companyNo: "",
        companyName: "",
      };
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/CompanyCodeDropdown",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            this.setState({
              ...this.state,
              CompanylistArray: data?.resultObject,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  DivisionListData = (value) => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/DivisionCodeDropdown?CompanyCode=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          // body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            this.setState({
              ...this.state,
              DivisionListArray: data?.resultObject,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  SectionListData = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/SectionDropdown",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            this.setState({
              ...this.state,
              sectionListArray: data?.resultObject,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  GetActionTypeListData = (value) => {
    try {
      let postData = {
        id: 0,
        description: "",
        actioncategory: value ? value : this.state.ActionCatrgory,
      };
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/ActionTypeDropDown",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            this.setState({
              ...this.state,
              ActionTypelistArray: data?.resultObject,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  GetExitListData = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/TypeofExitDropdown",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            this.setState({
              ...this.state,
              exitOptionList: data?.resultObject,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  // GetVehicleListData = () => {
  //   let postData = { Mode: 'Vehicle' }
  //   fetch(process.env.REACT_APP_WEB_SERVICE_URL + '/api/GGP/GetGGPMaster', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: 'Bearer ' + this.props.getToken,
  //     },
  //     body: JSON.stringify(postData),
  //   })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         return response.json()
  //       } else if (response.status === 401) {
  //         this.props.dispatch({ type: 'Token', value: '' })
  //         this.props.dispatch({ type: 'profile', value: '' })
  //         this.props.dispatch({ type: 'userType', value: '' })
  //       }
  //     })
  //     .then((data) => {
  //       if (data) {
  //         this.setState({ VehiclelistArray: data.MasterList })
  //       }
  //     })
  // }

  // GetTypeOfGoodsListData = () => {
  //   // alert('a')
  //   let postData = { Mode: 'GoodsType' }
  //   fetch(process.env.REACT_APP_WEB_SERVICE_URL + '/api/GGP/GetGGPMaster', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: 'Bearer ' + this.props.getToken,
  //     },
  //     body: JSON.stringify(postData),
  //   })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         return response.json()
  //       } else if (response.status === 401) {
  //         this.props.dispatch({ type: 'Token', value: '' })
  //         this.props.dispatch({ type: 'profile', value: '' })
  //         this.props.dispatch({ type: 'userType', value: '' })
  //       }
  //     })
  //     .then((data) => {
  //       if (data) {
  //         this.setState({ TypeofGoodslistArray: data.MasterList })
  //       }
  //     })
  // }

  // GetExitPurposeListData = () => {
  //   // alert('a')
  //   let postData = { Mode: 'ExitPurpose' }
  //   fetch(process.env.REACT_APP_WEB_SERVICE_URL + '/api/GGP/GetGGPMaster', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: 'Bearer ' + this.props.getToken,
  //     },
  //     body: JSON.stringify(postData),
  //   })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         return response.json()
  //       } else if (response.status === 401) {
  //         this.props.dispatch({ type: 'Token', value: '' })
  //         this.props.dispatch({ type: 'profile', value: '' })
  //         this.props.dispatch({ type: 'userType', value: '' })
  //       }
  //     })
  //     .then((data) => {
  //       if (data) {
  //         this.setState({ ExitPurposelistArray: data.MasterList })
  //       }
  //     })
  // }

  // GetAuthCategoryListData = () => {
  //   // alert('a')
  //   let postData = { Mode: 'AuthCategory' }
  //   fetch(process.env.REACT_APP_WEB_SERVICE_URL + '/api/GGP/GetGGPMaster', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: 'Bearer ' + this.props.getToken,
  //     },
  //     body: JSON.stringify(postData),
  //   })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         return response.json()
  //       } else if (response.status === 401) {
  //         this.props.dispatch({ type: 'Token', value: '' })
  //         this.props.dispatch({ type: 'profile', value: '' })
  //         this.props.dispatch({ type: 'userType', value: '' })
  //       }
  //     })
  //     .then((data) => {
  //       if (data) {
  //         this.setState({ AuthCategorylistArray: data.MasterList })
  //       }
  //     })
  // }

  // GetExitTimeListData = () => {
  //   // alert('a')
  //   let postData = { Mode: 'ExitTime' }
  //   fetch(process.env.REACT_APP_WEB_SERVICE_URL + '/api/GGP/GetGGPMaster', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: 'Bearer ' + this.props.getToken,
  //     },
  //     body: JSON.stringify(postData),
  //   })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         return response.json()
  //       } else if (response.status === 401) {
  //         this.props.dispatch({ type: 'Token', value: '' })
  //         this.props.dispatch({ type: 'profile', value: '' })
  //         this.props.dispatch({ type: 'userType', value: '' })
  //       }
  //     })
  //     .then((data) => {
  //       if (data) {
  //         this.setState({ ExitTimelistArray: data.MasterList })
  //       }
  //     })
  // }

  // GetStatusofGoodsListData = () => {
  //   // alert('a')
  //   let postData = { Mode: 'StatusofGoods' }
  //   fetch(process.env.REACT_APP_WEB_SERVICE_URL + '/api/GGP/GetGGPMaster', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: 'Bearer ' + this.props.getToken,
  //     },
  //     body: JSON.stringify(postData),
  //   })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         return response.json()
  //       } else if (response.status === 401) {
  //         this.props.dispatch({ type: 'Token', value: '' })
  //         this.props.dispatch({ type: 'profile', value: '' })
  //         this.props.dispatch({ type: 'userType', value: '' })
  //       }
  //     })
  //     .then((data) => {
  //       if (data) {
  //         this.setState({ StatusofGoodslistArray: data.MasterList })
  //       }
  //     })
  // }

  GetAttachmentslistData = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/GetAttachments?ReferenceNo=${this.state.Referenceno}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              AttachmentslistArray: data.resultObject,
              AttachmentsLoader: "No",
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  showFirstStaffPopup = () => {
    this.setState({ getEmployeeFirstShow: true });
  };

  formShowFirstStaffPopup = () => {
    this.setState({ formGetEmployeeFirstShow: true });
  };

  approverShowFirstStaffPopup = () => {
    this.setState({ approverGetEmployeeFirstShow: true });
  };

  hideFirstStaffPopup = () => {
    this.setState({ getEmployeeFirstShow: false });
    this.setState({
      popupEmployeeId: "",
      popupEmployeeName: "",
      popupSection: 0,
      StaffDetailslistArray: [],
    });
  };

  formHideFirstStaffPopup = () => {
    this.setState({ formGetEmployeeFirstShow: false });
    this.setState({
      formGetEmployeeFirstShow: "",
      formPopupEmployeeName: "",
      formPopupSection: 0,
      formStaffDetailslistArray: [],
    });
  };

  approverHideFirstStaffPopup = () => {
    this.setState({ approverGetEmployeeFirstShow: false });
    this.setState({
      approverpopupEmployeeName: "",
      approverpopupSection: 0,
      approverStaffDetailslistArray: [],
    });
  };

  showSecondAuthorizedNamePopup = () => {
    this.setState({ getAuthorizedNameSecondShow: true });
  };

  hideSecondAuthorizedNamePopup = () => {
    this.setState({ getAuthorizedNameSecondShow: false });
    this.setState({
      popupEmployeeId: "",
      popupEmployeeName: "",
      popupSection: 0,
      StaffDetailslistArray: [],
    });
  };

  showAuthorizedCompanySecondPopup = () => {
    this.setState({ getAuthorizedCompanySecondShow: true });
  };

  hideAuthorizedCompanySecondPopup = () => {
    this.setState({ getAuthorizedCompanySecondShow: false });
    this.setState({
      popupCompanyNo: "",
      popupCompanyName: "",
      companylistArray: [],
    });
  };

  searchEmployeeClear = () => {
    this.setState({
      popupEmployeeId: "",
      popupEmployeeName: "",
      popupSection: 0,
      StaffDetailslistArray: [],
      stafflistArraySpin: "none",
      section: "",
    });
  };

  approversearchEmployeeClear = () => {
    this.setState({
      approverpopupEmployeeId: "",
      approverpopupEmployeeName: "",
      approverpopupSection: 0,
      approverStaffDetailslistArray: [],
      stafflistArraySpin: "none",
    });
  };

  formSearchEmployeeClear = () => {
    this.setState({
      formPopupEmployeeId: "",
      formPopupEmployeeName: "",
      formPopupSection: 0,
      formStaffDetailslistArray: [],
    });
  };

  searchCompanyClear = () => {
    this.setState({
      popupCompanyNo: "",
      popupCompanyName: "",
      companylistArray: [],
    });
  };

  editAttachmentsShow = (Sequenceno, remarks) => {
    //alert(Remarks)
    this.setState({
      editAttachments: true,
      editAttachments_Sequenceno: Sequenceno,
      editAttachments_Remarks: remarks,
    });
  };

  editAttachmentsHide = () => {
    this.setState({
      editAttachments: false,
      editAttachments_Sequenceno: "",
      editAttachments_Filename: "",
      editAttachments_Filetype: "",
      editAttachments_Remarks: "",
      editAttachments_URL: "",
    });
  };

  getStaffDetails = (
    //rithika
    id,
    name,
    section,
    sectionName,
    department,
    division,
    designation,
    dateJoin
  ) => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/Dashboard/Employeedetails?EmployeeId=${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            //safik
            this.setState({
              RequesterId: id,
              phoneNumber: data?.resultObject.telno,
              address:
                data?.resultObject.address1 +
                data?.resultObject.address2 +
                data?.resultObject.address3 +
                data?.resultObject.address4,
              RequesterName: name,
              RequesterSection: section,
              RequesterSectionName: sectionName,
              RequesterDepartment: department,
              RequesterDivision: division,
              RequesterDesignation: designation,
              canStafNamePopover: "flex",
              getEmployeeFirstShow: false,
              RequesterDisplayName: id + " - " + name,
              popupEmployeeId: "",
              popupEmployeeName: "",
              popupSection: 0,
              StaffDetailslistArray: [],
              joiningDate: dateJoin,
            });
          }
          this.RequestTypeListData(id);
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (error) {
      this.props.dispatch({ type: "Referenceno", value: "" });
      this.props.dispatch({ type: "UserId", value: "" });
      this.props.dispatch({ type: "profile", value: "" });
      this.props.dispatch({ type: "headerTitle", value: "" });
      this.props.dispatch({ type: "Token", value: "" });
      this.props.dispatch({ type: "userType", value: "" });
    }
  };

  formGetStaffDetails = (
    id,
    name,
    section,
    sectionName,
    department,
    division,
    designation
  ) => {
    this.setState({
      formRequesterId: id,
      formRequesterName: name,
      formRequesterSection: section,
      formRequesterSectionName: sectionName,
      formRequesterDepartment: department,
      formRequesterDivision: division,
      formRequesterDesignation: designation,
      formCanStafNamePopover: "flex",
      formGetEmployeeFirstShow: false,
      formRequesterDisplayName: id + " - " + name,
      formPopupEmployeeId: "",
      formPopupEmployeeName: "",
      formPopupSection: 0,
      formStaffDetailslistArray: [],
    });
  };

  approverGetStaffDetails = (
    id,
    name,
    section,
    sectionName,
    department,
    division,
    designation
  ) => {
    this.setState({
      approverRequesterId: id,
      approverRequesterName: name,
      approverRequesterSection: section,
      approverRequesterSectionName: sectionName,
      approverRequesterDepartment: department,
      approverRequesterDivision: division,
      approverRequesterDesignation: designation,
      approverCanStafNamePopover: "flex",
      approverGetEmployeeFirstShow: false,
      approverRequesterDisplayName: id + " - " + name,
      approverpopupEmployeeId: "",
      approverpopupEmployeeName: "",
      approverpopupSection: 0,
      approverStaffDetailslistArray: [],
    });
  };

  getAuthorizedNameDetails = (id, name) => {
    this.setState({
      Authorizedid: id,
      Authorizedname: name,
      getAuthorizedNameSecondShow: false,
    });
    this.setState({
      popupEmployeeId: "",
      popupEmployeeName: "",
      popupSection: 0,
      StaffDetailslistArray: [],
    });
  };

  getCompanayDetails = (CompanyNo, CompanyName) => {
    this.setState({
      Authorizedcompany: CompanyNo + " - " + CompanyName,
      Authorizedcompanyname: CompanyNo + " - " + CompanyName,
      getAuthorizedCompanySecondShow: false,
    });
    this.setState({
      popupCompanyNo: "",
      popupCompanyName: "",
      companylistArray: [],
    });
  };

  cancelattachmentDelete = () => {
    this.setState({ attachmentdeletePopup: false, goodsItemdeleteid: "" });
  };

  deleteAttachment = (id) => {
    this.setState({ attachmentdeletePopup: true, attachmentdeleteid: id });
  };

  confirmattachmentDelete = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/DeleteAttachments?ReferenceNo=${
            this.state.Referenceno
          }&SequenceNo=${parseInt(this.state.attachmentdeleteid)}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              attachmentdeleteid: "",
              attachmentdeletePopup: false,
            });
            this.GetAttachmentslistData();
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.Referenceno !== this.state.Referenceno) {
      if (this.state.popupSection?.id) {
        this.saveAsDraft();
      }
    }
  }

  handleCheck = (content, delta, source, editor) => {
    const plainText = editor.getText();
    this.setState({
      ...this.state,
      createDescription: content,
      wordCount: {
        ...this.state.wordCount,
        count: plainText.trim().length,
      },
    });
  };

  // handleCheck = (value) => {
  //   this.setState({
  //     ...this.state,
  //     createDescription: value,
  //     wordCount: {
  //       ...this.state.wordCount,
  //       count: value.length,
  //     },
  //   });
  // };

  handleChange = (e) => {
    switch (e.target.name) {
      case "popupEmployeeId":
        this.setState({ ...this.state, popupEmployeeId: e.target.value });
        break;
      case "sequence_no":
        this.setState({ ...this.state, sequence_no: e.target.value });
        break;

      case "formPopupEmployeeId":
        this.setState({ ...this.state, formPopupEmployeeId: e.target.value });
        break;
      case "approverpopupEmployeeId":
        this.setState({
          ...this.state,
          approverpopupEmployeeId: e.target.value,
        });
        break;

      case "popupEmployeeName":
        this.setState({ ...this.state, popupEmployeeName: e.target.value });
        break;
      case "formPopupEmployeeName":
        this.setState({ ...this.state, formPopupEmployeeName: e.target.value });
        break;
      case "approverpopupEmployeeName":
        this.setState({
          ...this.state,
          approverpopupEmployeeName: e.target.value,
        });
        break;

      case "Single":
        this.setState({
          ...this.state,
          ActionCatrgory: e.target.value,
          actionType: "",
          companyCode: "",
          divisionCode: "",
          employeeID: "",
          positionID: "",
          salaryGrade: "",
          workingGroup: "",
          addInfo: "",
        });
        this.GetActionTypeListData(e.target.value);
        break;
      case "Group":
        this.setState({
          ...this.state,
          ActionCatrgory: e.target.value,
          actionType: "",
          companyCode: "",
          divisionCode: "",
          employeeID: "",
          positionID: "",
          salaryGrade: "",
          workingGroup: "",
          addInfo: "",
        });
        this.GetActionTypeListData(e.target.value);
        break;
      case "None":
        this.setState({
          ...this.state,
          ActionCatrgory: e.target.value,
          actionType: "",
          companyCode: "",
          divisionCode: "",
          employeeID: "",
          positionID: "",
          salaryGrade: "",
          workingGroup: "",
          addInfo: "",
        });
        this.GetActionTypeListData(e.target.value);
        break;
      case "description":
        this.setState({
          ...this.state,
          createDescription: e.target.value,
          wordCount: {
            ...this.state.wordCount,
            count: e.target.value.length,
          },
        });
        break;

      case "editReferences_Reflink":
        this.setState({
          ...this.state,
          editReferences_Reflink: e.target.value,
        });
        break;
      case "editReferences_Remarks":
        this.setState({
          ...this.state,
          editReferences_Remarks: e.target.value,
        });
        break;
      case "editAttachments_Remarks":
        this.setState({
          ...this.state,
          editAttachments_Remarks: e.target.value,
        });
        break;
      case "Others":
        this.setState({ ...this.state, addInfo: e.target.value });
        break;
      default:
        break;
    }
  };

  joiningDate = (date) => {
    this.setState({ joiningDate: date });
  };
  startDate = (date) => {
    this.setState({ startDate: date });
  };
  endDate = (date) => {
    this.setState({ endDate: date });
  };

  lastDate = (date) => {
    this.setState({ lastDate: date });
  };

  handleSelectFormFields = (selectedOption, type) => {
    try {
      switch (type) {
        case "requestTypeOptionList":
          if (!this.state.popupSection?.id) {
            fetch(
              process.env.REACT_APP_WEB_SERVICE_URL +
                `/api/eDoc/GenerateReferenceNo?StaffId=${this.state.RequesterId}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + this.props.getToken,
                },
              }
            )
              .then((response) => {
                if (response.status === 200) {
                  return response.json();
                } else if (response.status === 401) {
                  this.props.dispatch({ type: "Referenceno", value: "" });
                  this.props.dispatch({ type: "UserId", value: "" });
                  this.props.dispatch({ type: "profile", value: "" });
                  this.props.dispatch({ type: "headerTitle", value: "" });
                  this.props.dispatch({ type: "Token", value: "" });
                  this.props.dispatch({ type: "userType", value: "" });
                  this.props.dispatch({ type: "userName", value: "" });
                }
              })
              .then((data) => {
                if (data) {
                  this.setState({
                    ...this.state,
                    Referenceno: data.resultObject,
                    popupSection: selectedOption,
                    step3: !this.state.step3,
                    step4: !this.state.step4,
                  });
                }
              })
              .catch((error) => {
                this.props.dispatch({ type: "Referenceno", value: "" });
                this.props.dispatch({ type: "UserId", value: "" });
                this.props.dispatch({ type: "profile", value: "" });
                this.props.dispatch({ type: "headerTitle", value: "" });
                this.props.dispatch({ type: "Token", value: "" });
                this.props.dispatch({ type: "userType", value: "" });
                this.props.dispatch({ type: "userName", value: "" });
              });
          } else {
            this.setState({
              ...this.state,
              popupSection: selectedOption,
            });
          }
          break;
        case "actionTypeOptionList":
          this.setState({
            actionType: selectedOption,
            formRequesterId: "",
            formRequesterDisplayName: "",
          });
          break;
        case "employeeID":
          this.setState({ employeeID: selectedOption });
          break;
        case "positionID":
          this.setState({ positionID: selectedOption });
          break;
        case "salaryGrade":
          this.setState({ salaryGrade: selectedOption });
          break;
        case "workingGroup":
          this.setState({ workingGroup: selectedOption });
          break;
        case "addInfo":
          this.setState({ addInfo: selectedOption });
          break;
        case "section":
          this.setState({ section: selectedOption });
          break;
        case "approversection":
          this.setState({ approversection: selectedOption });
          break;
        case "formSection":
          this.setState({ formSection: selectedOption });
          break;

        case "typeOfExit":
          this.setState({ typeOfExit: selectedOption });
          break;
        case "phoneNumber":
          this.setState({ phoneNumber: selectedOption });
          break;
        case "address":
          this.setState({ address: selectedOption });
          break;
        case "companyCode":
          this.setState({ companyCode: selectedOption });
          this.DivisionListData(selectedOption.value);
          break;
        case "divisionCode":
          this.setState({ divisionCode: selectedOption });
          break;
        default:
          break;
      }
    } catch (e) {
      console.log(e);
    }
  };

  searchEmployee = () => {
    try {
      this.setState({ StaffDetailslistArraySpin: "" });
      let postData = {
        employeeId: this.state.popupEmployeeId,
        name: this.state.popupEmployeeName,
        section: this.state.section.value,
        employeeType: "All",
      };
      fetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/StaffInfo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ StaffDetailslistArray: data.resultObject });
            this.setState({ StaffDetailslistArraySpin: "none" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  formSearchEmployee = () => {
    try {
      this.setState({ formStaffDetailslistArraySpin: "" });
      let postData = {
        employeeId: this.state.formPopupEmployeeId,
        name: this.state.formPopupEmployeeName,
        section: this.state.formPopupSection.value,
        employeeType: "All",
      };
      fetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/StaffInfo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ formStaffDetailslistArray: data.resultObject });
            this.setState({ formStaffDetailslistArraySpin: "none" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  approversearchEmployee = () => {
    try {
      this.setState({ approverStaffDetailslistArraySpin: "" });
      let postData = {
        employeeId: this.state.approverpopupEmployeeId,
        name: this.state.approverpopupEmployeeName,
        section: this.state.approverpopupSection.value,
        employeeType: "All",
      };
      fetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/StaffInfo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ approverStaffDetailslistArray: data.resultObject });
            this.setState({ approverStaffDetailslistArraySpin: "none" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  addReferences = () => {
    this.setState({ ReferencesAdd: "", showReferenceRequired: "none" });
  };

  addApproverReferences = () => {
    this.setState({
      ApproverReferencesAdd: true,
      ApproverShowReferenceRequired: "none",
      sequence_no: this.state?.workflowid?.length + 1,
    });
  };

  deleteReferences = (id) => {
    this.setState({ referencesdeletePopup: true, referencesdeleteid: id });
  };

  deleteApproverReferences = (id) => {
    this.setState({
      ApproverReferencesdeletePopup: true,
      ApproverReferencesdeleteid: id,
    });
  };

  References_Cancel = () => {
    this.setState({
      ReferencesAdd: "none",
      References_Reflink: "",
      References_Remarks: "",
    });
  };

  editReferencesHide = () => {
    this.setState({ editReferences: false });
  };
  cancelreferencesDelete = () => {
    this.setState({ referencesdeletePopup: false, referencesdeleteid: "" });
  };

  confirmreferencesDelete = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/DeleteReferenceLink?SequenceNo=${parseInt(
            this.state.referencesdeleteid
          )}&ReferenceNo=${this.state.Referenceno}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              referencesdeleteid: "",
              referencesdeletePopup: false,
            });
            this.GetReferenceLinkslistData();
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  editReferencesShow = (Sequenceno, Reflink, Remarks) => {
    this.setState({
      editReferences: true,
      editReferences_Sequenceno: Sequenceno,
      editReferences_Reflink: Reflink,
      editReferences_Remarks: Remarks,
    });
  };

  editReferencesHide = () => {
    this.setState({
      editReferences: false,
      editReferences_Reflink: "",
      editReferences_Remarks: "",
    });
  };

  References_Save = () => {
    try {
      this.setState({ ReferencesLoader: "Yes" });
      let postData = {
        sequenceNo: 0,
        referenceNo: this.state.Referenceno,
        reflink: this.state.editReferences_Reflink,
        remarks: this.state.editReferences_Remarks,
      };

      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/InsertReferenceLink",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              ReferencesAdd: "none",
              showReferenceRequired: "none",
              editReferences: false,
              editReferences_Reflink: "",
              editReferences_Remarks: "",
            });
            this.GetReferenceLinkslistData();
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  approverReferences_Save = (value, type) => {
    if (type !== "Update" && type !== "Delete") {
      const checkValue = this.state.approverRequesterId
        ? this.state.approverRequesterId
        : value.oriapproverid;
      for (const element of this.state?.workflowid || []) {
        if (element.oriapproverid === checkValue) {
          toast.info("Workflow ID already exists");
          return;
        }
      }
    }

    try {
      if (
        type == "Delete" || type == "Update"
          ? true
          : this.state.sequence_no && this.state.approverRequesterId
      ) {
        this.setState({ ApproverReferencesLoader: "Yes", isLoading: true });
        let postData = {
          workflowid: type ? value.workflowid : 0,
          referenceno: type ? value.referenceno : this.state.Referenceno,
          sequenceno: this.state.sequence_no
            ? this.state.sequence_no
            : value.sequenceno,
          oriapproverid: this.state.approverRequesterId
            ? this.state.approverRequesterId
            : value.oriapproverid,
          oriapprovername: this.state.approverRequesterName
            ? this.state.approverRequesterName
            : value.oriapprovername,
          section: this.state.approverRequesterSection
            ? this.state.approverRequesterSection
            : value.section,
          wfstatus: type ? value.wfstatus : "",
          comments: type ? value.comments : "",
          mode: type ? type : "Add",
          isEdit: type ? value.isEdit : 1,
        };

        fetch(
          process.env.REACT_APP_WEB_SERVICE_URL +
            "/api/eDoc/InsertUpdateApprovers",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.props.getToken,
            },
            body: JSON.stringify(postData),
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Referenceno", value: "" });
              this.props.dispatch({ type: "UserId", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "headerTitle", value: "" });
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
              this.props.dispatch({ type: "userName", value: "" });
            }
          })
          .then((data) => {
            if (data) {
              this.setState({
                approverEdit: { status: false, value: "" },
                sequence_no: "",
                ApproverReferencesAdd: "none",
                ApproverShowReferenceRequired: "none",
                approverRequesterId: "",
                approverRequesterName: "",
                approverRequesterSection: "",
                approverRequesterSectionName: "",
                approverRequesterDepartment: "",
                approverRequesterDivision: "",
                approverRequesterDesignation: "",
                approverCanStafNamePopover: "flex",
                approverGetEmployeeFirstShow: "",
                approverRequesterDisplayName: "",
                approverpopupEmployeeId: "",
                approverpopupEmployeeName: "",
                approverpopupSection: 0,
                approverStaffDetailslistArray: [],
              });
            }
          })
          .then(() => {
            fetch(
              process.env.REACT_APP_WEB_SERVICE_URL +
                `/api/eDoc/GetApprovers?ReferenceNo=${this.state.Referenceno}`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + this.props.getToken,
                },
              }
            )
              .then((response) => {
                if (response.status === 200) {
                  return response.json();
                } else if (response.status === 401) {
                  this.props.dispatch({ type: "Referenceno", value: "" });
                  this.props.dispatch({ type: "UserId", value: "" });
                  this.props.dispatch({ type: "profile", value: "" });
                  this.props.dispatch({ type: "headerTitle", value: "" });
                  this.props.dispatch({ type: "Token", value: "" });
                  this.props.dispatch({ type: "userType", value: "" });
                  this.props.dispatch({ type: "userName", value: "" });
                }
              })
              .then((data) => {
                if (data.resultObject) {
                  this.setState({
                    ...this.state,
                    workflowid: data.resultObject,
                    stepbarballon: 2,
                    isLoading: false,
                  });
                }
              })
              .catch((error) => {
                this.props.dispatch({ type: "Referenceno", value: "" });
                this.props.dispatch({ type: "UserId", value: "" });
                this.props.dispatch({ type: "profile", value: "" });
                this.props.dispatch({ type: "headerTitle", value: "" });
                this.props.dispatch({ type: "Token", value: "" });
                this.props.dispatch({ type: "userType", value: "" });
                this.props.dispatch({ type: "userName", value: "" });
              });
          })
          .catch((error) => {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          });
      } else {
        this.setState({ errorStatus: true });
      }
    } catch (e) {
      console.log(e);
    }
  };

  UpdateAttachments = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/UpdateAttachments?ReferenceNo=${
            this.state.Referenceno
          }&SequenceNo=${parseInt(
            this.state.editAttachments_Sequenceno
          )}&Remarks=${this.state.editAttachments_Remarks}`,
        {
          method: "POST",
          processData: false,
          contentType: false,
          crossDomain: true,
          headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              editAttachments: false,
              editAttachments_Sequenceno: "",
              editAttachments_Filename: "",
              editAttachments_Filetype: "",
              editAttachments_URL: "",
              editAttachments_Remarks: "",
            });
            this.GetAttachmentslistData();
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  GetReferenceLinkslistData = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/GetReferenceLink?ReferenceNo=${this.state.Referenceno}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              ReferenceLinkslistArray: data.resultObject,
              ReferencesLoader: "No",
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  UpdateReferences = () => {
    //alert(this.props.Referenceno)
    try {
      let postData = {
        sequenceNo: this.state.editReferences_Sequenceno,
        referenceNo: this.props.Referenceno,
        reflink: this.state.editReferences_Reflink,
        remarks: this.state.editReferences_Remarks,
      };
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/UpdateReferenceLink",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              editReferences: false,
              editReferences_Reflink: "",
              editReferences_Remarks: "",
            });
            this.GetReferenceLinkslistData();
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  saveRequesterInformation = (loopdata) => {
    try {
      if (
        this.state.ActionCatrgory != "Group" &&
        this.state.ActionCatrgory != "None"
      ) {
        if (this.state.wordCount.count > this.state.wordCount.intialValue) {
          toast.info(
            `Description must not exceed ${this.state.wordCount.intialValue} characters`
          );
          return;
        }
        if (!this.state.createDescription) {
          this.setState({ ...this.state, errorStatus: true });
          return;
        }
      }

      if (!this.state.AttachmentslistArray?.length) {
        this.setState({ ...this.state, errorStatus: true });
        return;
      }

      if (
        this.state.AttachmentslistArray?.length &&
        this.state.popupSection?.value?.includes("Employee Clearance")
          ? this.state.typeOfExit != 0 &&
            this.state.phoneNumber &&
            this.state.address
          : this.state.popupSection?.value == "HRIS"
          ? this.state.ActionCatrgory == "Single"
            ? this.state.actionType &&
              this.state.companyCode &&
              this.state.divisionCode &&
              (this.state.employeeID || this.state.formRequesterId) &&
              this.state.positionID &&
              this.state.salaryGrade &&
              this.state.workingGroup &&
              this.state.addInfo
            : this.state.ActionCatrgory == "Group"
            ? this.state.ActionCatrgory
            : this.state.ActionCatrgory
          : this.state.AttachmentslistArray?.length
      ) {
        this.setState({ isLoading: true });
        this.saveDraftRequesterInformation("Next");

        fetch(
          process.env.REACT_APP_WEB_SERVICE_URL +
            `/api/eDoc/InsertWorkFlow?ReferenceNo=${this.state.Referenceno}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.props.getToken,
            },
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Referenceno", value: "" });
              this.props.dispatch({ type: "UserId", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "headerTitle", value: "" });
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
              this.props.dispatch({ type: "userName", value: "" });
            }
          })
          .then((data) => {
            if (data.resultObject) {
              this.setState({
                ...this.state,
                workflowid: data.resultObject,
                stepbarballon: loopdata ? 1 : 2,
                isLoading: false,
              });
            }
          })
          .then(() => {
            fetch(
              process.env.REACT_APP_WEB_SERVICE_URL +
                `/api/eDoc/GetApprovers?ReferenceNo=${this.state.Referenceno}`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + this.props.getToken,
                },
              }
            )
              .then((response) => {
                if (response.status === 200) {
                  return response.json();
                } else if (response.status === 401) {
                  this.props.dispatch({ type: "Referenceno", value: "" });
                  this.props.dispatch({ type: "UserId", value: "" });
                  this.props.dispatch({ type: "profile", value: "" });
                  this.props.dispatch({ type: "headerTitle", value: "" });
                  this.props.dispatch({ type: "Token", value: "" });
                  this.props.dispatch({ type: "userType", value: "" });
                  this.props.dispatch({ type: "userName", value: "" });
                }
              })
              .then((data) => {
                if (data.resultObject) {
                  this.setState({
                    ...this.state,
                    workflowid: data.resultObject,
                    stepbarballon: loopdata ? 1 : 2,
                  });
                }
                if (loopdata) {
                  if (!loopdata?.filePath && !loopdata?.fileRecord) {
                    toast.info("The specified file or path not found", {
                      position: toast.POSITION.TOP_CENTER,
                      autoClose: 2000,
                    });
                    return;
                  }

                  window.open(
                    `/signature?file=${encodeURIComponent(
                      loopdata.filePath ?? "null"
                    )}&sequenceNo=${encodeURIComponent(
                      loopdata.sequenceNo ?? ""
                    )}&referenceNo=${encodeURIComponent(
                      loopdata.referenceNo ?? ""
                    )}&filename=${encodeURIComponent(
                      loopdata.filename ?? ""
                    )}&location=${encodeURIComponent(
                      this.props.location.pathname ?? ""
                    )}`,
                    "_self"
                  );
                }
              })
              .catch((error) => {
                this.props.dispatch({ type: "Referenceno", value: "" });
                this.props.dispatch({ type: "UserId", value: "" });
                this.props.dispatch({ type: "profile", value: "" });
                this.props.dispatch({ type: "headerTitle", value: "" });
                this.props.dispatch({ type: "Token", value: "" });
                this.props.dispatch({ type: "userType", value: "" });
                this.props.dispatch({ type: "userName", value: "" });
              });
          })
          .catch((error) => {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          });
      } else {
        this.setState({ ...this.state, errorStatus: true });
        return;
      }
    } catch (e) {
      console.log(e);
    }
  };

  saveAsDraft = () => {
    try {
      if (this.state.Referenceno) {
        let postData = {
          referenceNo: this.state.Referenceno,
          status: 0,
          requesterId: parseInt(this.state.RequesterId),
          eDocTypeId: this.state.popupSection?.id
            ? parseInt(this.state.popupSection?.id)
            : 0,
          typeOfExit: this.state.typeOfExit?.id
            ? parseInt(this.state.typeOfExit?.id)
            : 0,
          // dateJoined: this.state.popupSection?.value?.includes(
          //   "Employee Clearance"
          // )
          //   ? this.state.dateJoin
          //   : this.state.joiningDate,
          // lastDayofService: this.state.lastDate,
          // dateJoined: this.state.popupSection?.value?.includes(
          //   "Employee Clearance"
          // )
          //   ? moment(this.state.dateJoin).format("yyyy-MM-DD") +
          //     "T18:30:00.000Z"
          //   : moment(this.state.joiningDate).format("yyyy-MM-DD") +
          //     "T18:30:00.000Z",

          dateJoined:
            moment(this.state.joiningDate).format("yyyy-MM-DD") +
            "T18:30:00.000Z",

          lastDayofService:
            moment(this.state.lastDate).format("yyyy-MM-DD") + "T18:30:00.000Z",

          phoneNumber: this.state.phoneNumber,
          address: this.state.address ? this.state.address : "",
          actionCategory: this.state.ActionCatrgory,
          companycode: this.state.companyCode?.value,
          divisioncode: this.state.divisionCode?.id,
          actionType: this.state.actionType?.id
            ? parseInt(this.state.actionType?.id)
            : 0,
          employeeId: parseInt(
            this.state.formRequesterId
              ? this.state.formRequesterId
              : this.state.employeeID
          ),
          employeeName: this.state?.formRequesterDisplayName
            ? this.state?.formRequesterDisplayName
            : "",
          // startDate: this.state.startDate,
          // endDate: this.state.endDate,
          startDate:
            moment(this.state.startDate).format("yyyy-MM-DD") +
            "T18:30:00.000Z",
          endDate:
            moment(this.state.endDate).format("yyyy-MM-DD") + "T18:30:00.000Z",
          positionId: this.state.positionID,
          salaryGrade: this.state.salaryGrade,
          workingGroup: this.state.workingGroup,
          additionalInformation: this.state.addInfo,
          description: this.state.createDescription,
          userId: parseInt(this.props.UserId),
          referenceLinkList: [
            {
              reflink: "",
              remarks: "",
            },
          ],
          attachmentList: [
            {
              referenceNo: "",
              filename: "",
              filetype: "",
              remarks: "",
              userId: 0,
            },
          ],
        };
        fetch(
          process.env.REACT_APP_WEB_SERVICE_URL +
            "/api/eDoc/InserteDocRequestDetails",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.props.getToken,
            },
            body: JSON.stringify(postData),
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Referenceno", value: "" });
              this.props.dispatch({ type: "UserId", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "headerTitle", value: "" });
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
              this.props.dispatch({ type: "userName", value: "" });
            }
          })
          .then((data) => {
            if (data.resultObject) {
              this.props.dispatch({
                type: "Referenceno",
                value: data.resultObject,
              });
              this.setState({
                Referenceno: data.resultObject,
                isRequesterInformation: "yes",
              });
            }
          })
          .catch((error) => {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          });
      }
    } catch (e) {
      console.log(e);
    }
  };

  saveDraftRequesterInformation = (value) => {
    try {
      if (
        this.state.ActionCatrgory != "Group" &&
        this.state.ActionCatrgory != "None"
      ) {
        if (this.state.wordCount.count > this.state.wordCount.intialValue) {
          toast.info(
            `Description must not exceed ${this.state.wordCount.intialValue} characters`
          );
          return;
        }

        if (!this.state.createDescription) {
          this.setState({ ...this.state, errorStatus: true });
          return;
        }
      }

      if (!this.state.AttachmentslistArray?.length) {
        this.setState({ ...this.state, errorStatus: true });
        return;
      }

      if (this.state.popupSection?.id) {
        if (
          this.state.AttachmentslistArray?.length &&
          this.state.popupSection?.value?.includes("Employee Clearance")
            ? this.state.typeOfExit != 0 &&
              this.state.phoneNumber &&
              this.state.address
            : this.state.popupSection?.value == "HRIS"
            ? this.state.ActionCatrgory == "Single"
              ? this.state.actionType &&
                this.state.companyCode &&
                this.state.divisionCode &&
                (this.state.employeeID || this.state.formRequesterId) &&
                this.state.positionID &&
                this.state.salaryGrade &&
                this.state.workingGroup &&
                this.state.addInfo
              : this.state.ActionCatrgory == "Group"
              ? this.state.ActionCatrgory &&
                this.state.AttachmentslistArray?.length
              : this.state.ActionCatrgory &&
                this.state.AttachmentslistArray?.length
            : this.state.AttachmentslistArray?.length
        ) {
          let temp = [];
          let temp1 = [];
          this.state.AttachmentslistArray?.map((data) =>
            temp.push({
              sequenceNo: data.sequenceNo,
              referenceNo: data.referenceNo,
              filename: data.filename,
              filetype: data.filetype,
              fileRecord: data.fileRecord,
              remarks: data.remarks,
            })
          );
          this.state.ReferenceLinkslistArray?.map((data) =>
            temp1.push({
              reflink: data.reflink,
              remarks: data.remarks,
            })
          );
          let postData = {
            referenceNo: this.state.Referenceno,
            requesterId: parseInt(this.state.RequesterId),
            eDocTypeId: this.state.popupSection?.id
              ? parseInt(this.state.popupSection?.id)
              : 0,
            typeOfExit: this.state.typeOfExit?.id
              ? parseInt(this.state.typeOfExit?.id)
              : 0,
            // dateJoined: this.state.popupSection?.value?.includes(
            //   "Employee Clearance"
            // )
            //   ? this.state.dateJoin
            //   : this.state.joiningDate,
            // lastDayofService: this.state.lastDate,

            // dateJoined: this.state.popupSection?.value?.includes(
            //   "Employee Clearance"
            // )
            //   ? moment(this.state.dateJoin).format("yyyy-MM-DD") +
            //     "T18:30:00.000Z"
            //   : moment(this.state.joiningDate).format("yyyy-MM-DD") +
            //     "T18:30:00.000Z",

            dateJoined:
              moment(this.state.joiningDate).format("yyyy-MM-DD") +
              "T18:30:00.000Z",

            lastDayofService:
              moment(this.state.lastDate).format("yyyy-MM-DD") +
              "T18:30:00.000Z",

            phoneNumber: this.state.phoneNumber,
            status: 1,
            address: this.state.address,
            actionCategory: this.state.ActionCatrgory,
            companycode: this.state.companyCode?.value,
            divisioncode: this.state.divisionCode?.id,
            actionType: this.state.actionType?.id
              ? parseInt(this.state.actionType?.id)
              : 0,
            employeeId: parseInt(
              this.state.formRequesterId
                ? this.state.formRequesterId
                : this.state.employeeID
            ),
            employeeName: this.state?.formRequesterDisplayName
              ? this.state?.formRequesterDisplayName
              : "",
            // startDate: this.state.startDate,
            // endDate: this.state.endDate,
            startDate:
              moment(this.state.startDate).format("yyyy-MM-DD") +
              "T18:30:00.000Z",
            endDate:
              moment(this.state.endDate).format("yyyy-MM-DD") +
              "T18:30:00.000Z",
            positionId: this.state.positionID,
            salaryGrade: this.state.salaryGrade,
            workingGroup: this.state.workingGroup,
            additionalInformation: this.state.addInfo,
            description: this.state.createDescription,
            userId: parseInt(this.props.UserId),
            referenceLinkList:
              temp1?.length > 0
                ? temp1
                : [
                    {
                      reflink: "",
                      remarks: "",
                    },
                  ],
            attachmentList:
              temp?.length > 0
                ? temp
                : [
                    {
                      sequenceNo: 0,
                      referenceNo: "",
                      filename: "",
                      filetype: "",
                      fileRecord: "",
                      remarks: "",
                    },
                  ],
          };

          fetch(
            process.env.REACT_APP_WEB_SERVICE_URL +
              "/api/eDoc/UpdateeDocRequestDetails",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.props.getToken,
              },
              body: JSON.stringify(postData),
            }
          )
            .then((response) => {
              if (response.status === 200) {
                return response.json();
              } else if (response.status === 401) {
                this.props.dispatch({ type: "Referenceno", value: "" });
                this.props.dispatch({ type: "UserId", value: "" });
                this.props.dispatch({ type: "profile", value: "" });
                this.props.dispatch({ type: "headerTitle", value: "" });
                this.props.dispatch({ type: "Token", value: "" });
                this.props.dispatch({ type: "userType", value: "" });
                this.props.dispatch({ type: "userName", value: "" });
              }
            })
            .then((data) => {
              if (data.resultObject) {
                this.props.dispatch({
                  type: "Referenceno",
                  value: data.resultObject,
                });
                this.setState({
                  Referenceno: data.resultObject,
                  isRequesterInformation: "yes",
                });
                if (value != "Next") {
                  toast.success("Request successfully saved as a draft.", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                  });
                  this.props.history.push({ pathname: "/dashboard" });
                }
              }
            })
            .catch((error) => {
              this.props.dispatch({ type: "Referenceno", value: "" });
              this.props.dispatch({ type: "UserId", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "headerTitle", value: "" });
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
              this.props.dispatch({ type: "userName", value: "" });
            });
        } else {
          this.setState({ ...this.state, errorStatus: true });
          return;
        }
      } else {
        this.setState({ ...this.state, errorStatus: true });
        return;
      }
    } catch (e) {
      console.log(e);
    }
  };

  saveDraftAuthorizedCarrier = () => {
    try {
      let postData = {
        Referenceno: this.props.Referenceno,
        Authorizedcategory: this.state.Authorizedcategory,
        Authorizedid: this.state.Authorizedid,
        Authorizedname: this.state.Authorizedname,
        Icnumber: this.state.Icnumber,
        Authorizedcompany: this.state.Authorizedcompany,
        Authorizedcompanyaddress: this.state.Authorizedcompanyaddress,
        Vehiclenumber: this.state.Vehiclenumber,
      };
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          "/api/GGP/UpdateAuthorizedCarrier",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ isAuthorizedCarrier: "yes" });
            toast.success("Request successfully saved as a draft.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
            this.props.history.push({ pathname: "/dashboard" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  saveDraftGoodsCategory = () => {
    try {
      let postData = {
        Referenceno: this.props.Referenceno,
        Goodscategory: this.state.Goodscategory,
        Exitpurpose: this.state.Exitpurpose,
        Exitpurposeremarks: this.state.Exitpurposeremarks,
        joiningDate:
          moment(this.state.joiningDate).format("yyyy-MM-DD") +
          "T18:30:00.000Z",
        lastDate:
          moment(this.state.lastDate).format("yyyy-MM-DD") + "T18:30:00.000Z",
        startDate:
          moment(this.state.startDate).format("yyyy-MM-DD") + "T18:30:00.000Z",
        endDate:
          moment(this.state.endDate).format("yyyy-MM-DD") + "T18:30:00.000Z",
        Goodstype: this.state.Goodstype,
        Goodsstatus: this.state.Goodsstatus,
        Goodsstatusremarks: this.state.Goodsstatusremarks,
        Goodsdestination: this.state.Goodsdestination,
        Goodsexittime: this.state.Goodsexittime,
        Goodsexittimeremarks: this.state.Goodsexittimeremarks,
        Goodscompanyaddress: this.state.Goodscompanyaddress,
        UserId: this.props.UserId,
      };
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/GGP/UpdateGoodsCategory",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ issaveGoodsCategory: "yes" });
            toast.success("Request successfully saved as a draft.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
            this.props.history.push({ pathname: "/dashboard" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  saveAuthorizedCarrier = () => {
    try {
      let postData = {
        Referenceno: this.props.Referenceno,
        Authorizedcategory: this.state.Authorizedcategory,
        Authorizedid: this.state.Authorizedid,
        Authorizedname: this.state.Authorizedname,
        Icnumber: this.state.Icnumber,
        Authorizedcompany: this.state.Authorizedcompany,
        Authorizedcompanyaddress: this.state.Authorizedcompanyaddress,
        Vehiclenumber: this.state.Vehiclenumber,
      };
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          "/api/GGP/UpdateAuthorizedCarrier",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ isAuthorizedCarrier: "yes" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  saveGoodsCategory = () => {
    try {
      let postData = {
        Referenceno: this.props.Referenceno,
        Goodscategory: this.state.Goodscategory,
        Exitpurpose: this.state.Exitpurpose,
        Exitpurposeremarks: this.state.Exitpurposeremarks,
        joiningDate:
          moment(this.state.joiningDate).format("yyyy-MM-DD") +
          "T18:30:00.000Z",
        lastDate:
          moment(this.state.lastDate).format("yyyy-MM-DD") + "T18:30:00.000Z",
        startDate:
          moment(this.state.startDate).format("yyyy-MM-DD") + "T18:30:00.000Z",
        endDate:
          moment(this.state.endDate).format("yyyy-MM-DD") + "T18:30:00.000Z",
        Goodstype: this.state.Goodstype,
        Goodsstatus: this.state.Goodsstatus,
        Goodsstatusremarks: this.state.Goodsstatusremarks,
        Goodsdestination: this.state.Goodsdestination,
        Goodsexittime: this.state.Goodsexittime,
        Goodsexittimeremarks: this.state.Goodsexittimeremarks,
        Goodscompanyaddress: this.state.Goodscompanyaddress,
        UserId: this.props.UserId,
      };
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/GGP/UpdateGoodsCategory",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ issaveGoodsCategory: "yes" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  formNext = (value, loopData) => {
    switch (value) {
      case 1:
        this.saveRequesterInformation(loopData);
        break;

      default:
        break;
    }
  };

  saveDraft = (value) => {
    switch (value) {
      case 1:
        if (this.validator1.allValid()) {
          this.saveDraftRequesterInformation();
          break;
        } else {
          this.validator1.showMessages();
          this.forceUpdate();
        }
        break;

      default:
        break;
    }
  };

  cancelHandler = () => {
    window.open(process.env.REACT_APP_ENV + "/dashboard", "_self");
  };

  submitHandler = () => {
    if (!this.state?.workflowid?.length) {
      toast.info("Workflow cannot be empty");
      return;
    }
    const checkSequence = this.state.popupSection.value.toLowerCase();
    if (
      !checkSequence.includes("hris") &&
      !checkSequence.includes("employee clearance")
    ) {
      let isUnique = true;
      let sequenceSet = new Set();
      this.state?.workflowid?.forEach((obj) => {
        if (sequenceSet.has(obj.sequenceno)) {
          isUnique = false;
        } else {
          sequenceSet.add(obj.sequenceno);
        }
      });
      let sequenceSetArray = [...sequenceSet];
      let largest = Math.max(...sequenceSetArray);
      let i = 1;
      while (i <= largest) {
        if (!sequenceSet.has(i) || !isUnique) {
          toast.info("Sequence Numbers are not in order");
          return;
        }
        i += 1;
      }
    }

    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/SubmitRequest?ReferenceNo=${this.state.Referenceno}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data.resultObject == 0) {
            toast.success("Request successfully created.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
            this.props.history.push({ pathname: "/dashboard" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  formprevious = (value) => {
    switch (value) {
      case 1:
        this.setState({
          step1: "block",
          step2: "none",
          step3: "none",
          step4: "none",
          step5: "none",
          stepbarballon: 1,
        });
        break;

      default:
        break;
    }
  };

  progressSetps = (value) => {
    switch (value) {
      case 1:
        this.setState({ stepbarballon: 1 });
        break;
      case 2:
        this.saveRequesterInformation();
        break;

      default:
        break;
    }
  };

  onDrop = (acceptedFiles) => {
    try {
      if (this.state.Referenceno) {
        this.setState({
          showAttachedRequired: false,
          AttachmentsLoader: "Yes",
        });
        acceptedFiles.map((file) => {
          if (file.size > 104857600) {
            toast.info("The maximum file size is 100 MB.");
            this.setState({
              showAttachedRequired: false,
              AttachmentsLoader: "No",
            });
            return;
          }
          let data = new FormData();

          data.append("files", file);
          fetch(
            process.env.REACT_APP_WEB_SERVICE_URL +
              `/api/eDoc/UploadAttachments?ReferenceNo=${
                this.state.Referenceno
              }&UserId=${this.props.UserId}&Remarks=${""}`,
            {
              method: "POST",
              processData: false,
              contentType: false,
              crossDomain: true,
              headers: {
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + this.props.getToken,
              },
              body: data,
            }
          )
            .then((response) => {
              if (response.status === 200) {
                return response.json();
              } else if (response.status === 401) {
                this.props.dispatch({ type: "Referenceno", value: "" });
                this.props.dispatch({ type: "UserId", value: "" });
                this.props.dispatch({ type: "profile", value: "" });
                this.props.dispatch({ type: "headerTitle", value: "" });
                this.props.dispatch({ type: "Token", value: "" });
                this.props.dispatch({ type: "userType", value: "" });
                this.props.dispatch({ type: "userName", value: "" });
              }
            })
            .then((data) => {
              if (data) {
                this.GetAttachmentslistData();
              }
            })
            .catch((error) => {
              this.props.dispatch({ type: "Referenceno", value: "" });
              this.props.dispatch({ type: "UserId", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "headerTitle", value: "" });
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
              this.props.dispatch({ type: "userName", value: "" });
            });
        });
      } else {
        this.setState({
          step1: "block",
          step2: "none",
          step3: "none",
          step4: "none",
          step5: "none",
          stepbarballon: 1,
        });
        if (this.validator1.allValid()) {
        } else {
          this.validator1.showMessages();
          this.forceUpdate();
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  companysearchnumb = (val) => {
    this.setState({ SearchCompanyNo: val });
  };
  getVehiclenumber = (val) => {
    this.setState({ Vehiclenumber: val });
  };

  _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.searchEmployee();
    }
  };

  render() {
    let RequestTypeOptionList = [];
    let companyOptionList = [];
    let actionTypeOptionList = [];
    let exitOptionList = [];
    let divisionOptionList = [];
    let SectionTypeOptionList = [];

    if (this.state.CompanylistArray.length > 0) {
      this.state.CompanylistArray.map((data) => {
        let sData = {
          id: data.companyNo,
          label: data.companyName,
          value: data.companyNo,
        };
        companyOptionList.push(sData);
        return null;
      });
    }
    if (this.state.sectionListArray.length > 0) {
      this.state.sectionListArray.map((data) => {
        let sData = {
          id: data.id,
          label: data.description,
          value: data.code,
        };
        SectionTypeOptionList.push(sData);
        return null;
      });
    }
    if (this.state.exitOptionList.length > 0) {
      this.state.exitOptionList.map((data) => {
        let sData = {
          id: data.id,
          label: data.description,
          value: data.description,
        };
        exitOptionList.push(sData);
        return null;
      });
    }
    if (this.state.DivisionListArray.length > 0) {
      this.state.DivisionListArray.map((data) => {
        let sData = {
          id: data.code,
          label: data.description,
          value: data.code,
        };
        divisionOptionList.push(sData);
        return null;
      });
    }

    if (this.state.ActionTypelistArray.length > 0) {
      this.state.ActionTypelistArray.map((data) => {
        let sData = {
          id: data.id,
          label: data.description,
          value: data.description,
        };
        actionTypeOptionList.push(sData);
        return null;
      });
    }

    if (this.state.RequestlistArray.length > 0) {
      this.state.RequestlistArray.map((data) => {
        let sData = {
          id: data.eDocTypeId,
          label: data.eDocType,
          value: data.eDocType,
        };
        RequestTypeOptionList.push(sData);
        return null;
      });
    }

    return (
      <>
        <LoadingOverlay
          active={this.state.isLoading}
          spinner
          styles={{
            overlay: (base) => ({
              ...base,
              background: "rgba(223, 223, 223, 0.5)",
            }),
          }}
        >
          <Breadcrumb>
            <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
              Dashboard
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Create Request</Breadcrumb.Item>
          </Breadcrumb>
          <Modal show={this.state.editReferences} size="lg">
            <Modal.Header>Edit</Modal.Header>
            <Modal.Body>
              <section className="p-3">
                <div className="form-group row mb-1">
                  <label
                    for="auth-name"
                    className="col-sm-3 col-form-label text-muted"
                  >
                    Reference Link
                  </label>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="editReferences_Reflink"
                        value={this.state.editReferences_Reflink}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label
                    for="auth-name"
                    className="col-sm-3 col-form-label text-muted"
                  >
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="editReferences_Remarks"
                        defaultValue={this.state.editReferences_Remarks}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <Button
                    className="btn btn-light"
                    onClick={() => this.editReferencesHide()}
                  >
                    {" "}
                    Cancel{" "}
                  </Button>
                  <Button
                    className="btn btn-primary-01 ml-3"
                    onClick={this.UpdateReferences}
                  >
                    {" "}
                    Update{" "}
                  </Button>
                </div>
              </section>
            </Modal.Body>
          </Modal>
          <Modal show={this.state.referencesdeletePopup}>
            <Modal.Header>Delete Confirmation</Modal.Header>
            <Modal.Body>
              <div className="alert alert-danger" role="alert">
                Are you sure you want to delete?
              </div>
              <hr></hr>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={this.cancelreferencesDelete}
                >
                  {" "}
                  No{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={this.confirmreferencesDelete}
                >
                  {" "}
                  Yes{" "}
                </Button>
              </div>
            </Modal.Body>
          </Modal>
          <Modal show={this.state.getEmployeeFirstShow} size="xl">
            <Modal.Header>Employee Look Up</Modal.Header>
            <Modal.Body>
              <section className="p-3">
                <div className="form-group row mb-1">
                  <label
                    for="auth-name"
                    className="col-sm-3 col-form-label text-muted"
                  >
                    Employee Id
                  </label>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <input
                        type="number"
                        className="form-control"
                        name="popupEmployeeId"
                        value={this.state.popupEmployeeId}
                        onChange={this.handleChange}
                        onKeyDown={this._handleKeyDown}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label
                    for="auth-name"
                    className="col-sm-3 col-form-label text-muted"
                  >
                    Employee Name
                  </label>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="popupEmployeeName"
                        value={this.state.popupEmployeeName}
                        onChange={this.handleChange}
                        // onKeyDown={this._handleKeyDown}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label
                    for="auth-cat"
                    className="col-sm-3 col-form-label text-muted"
                  >
                    Section
                  </label>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <Select
                        value={this.state.section}
                        options={SectionTypeOptionList}
                        onChange={(value) =>
                          this.handleSelectFormFields(value, "section")
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <Button
                    className="btn btn-light"
                    onClick={() => this.searchEmployeeClear()}
                  >
                    {" "}
                    Clear{" "}
                  </Button>
                  <Button
                    className="btn btn-primary-01 ml-3"
                    onClick={this.searchEmployee}
                  >
                    {" "}
                    Search{" "}
                  </Button>
                </div>
              </section>
              <hr></hr>

              <section>
                <h2 className="fs-title"> </h2>
                <div className="table-responsive max-height-280">
                  <table className="table table-hover">
                    <thead className="thead-lightBlue">
                      <tr>
                        <th scope="col"> Action </th>
                        <th scope="col"> Employee No </th>
                        <th scope="col"> User Name </th>
                        <th scope="col"> Account </th>
                        <th scope="col"> Email </th>
                        <th scope="col"> Section </th>
                        <th scope="col"> Section Name </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.StaffDetailslistArray?.map((staff, index) => (
                        <tr
                          className="cursor-pointer"
                          onClick={() =>
                            this.getStaffDetails(
                              staff.employeeId,
                              staff.name,
                              staff.section,
                              staff.sectionName,
                              staff.department,
                              staff.division,
                              staff.designation,
                              staff.dateJoin
                            )
                          }
                        >
                          <td>
                            {" "}
                            <p>
                              {" "}
                              <span className="material-icons-outlined select-employee-icon">
                                {" "}
                                how_to_reg{" "}
                              </span>{" "}
                            </p>{" "}
                          </td>
                          <td> {staff.employeeId} </td>
                          <td> {staff.name} </td>
                          <td> ({staff.account}) </td>
                          <td> {staff.email} </td>
                          <td> {staff.section} </td>
                          <td> {staff.sectionName} </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {(() => {
                    if (
                      this.state.StaffDetailslistArray.length <= 0 &&
                      this.state.StaffDetailslistArraySpin === "none"
                    ) {
                      return <p className="text-center">No record found.</p>;
                    }
                  })()}
                  <p className="text-center">
                    <Spinner
                      animation="border"
                      variant="primary"
                      style={{ display: this.state.StaffDetailslistArraySpin }}
                      className="text-center"
                    />
                  </p>
                </div>
              </section>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-light"
                onClick={() => this.hideFirstStaffPopup()}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal show={this.state.approverGetEmployeeFirstShow} size="xl">
            <Modal.Header>Employee Look Up</Modal.Header>
            <Modal.Body>
              <section className="p-3">
                <div className="form-group row mb-1">
                  <label
                    for="auth-name"
                    className="col-sm-3 col-form-label text-muted"
                  >
                    Employee Id
                  </label>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <input
                        type="number"
                        className="form-control"
                        name="approverpopupEmployeeId"
                        value={this.state.approverpopupEmployeeId}
                        onChange={this.handleChange}
                        onKeyDown={this._handleKeyDown}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label
                    for="auth-name"
                    className="col-sm-3 col-form-label text-muted"
                  >
                    Employee Name
                  </label>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="approverpopupEmployeeName"
                        value={this.state.approverpopupEmployeeName}
                        onChange={this.handleChange}
                        // onKeyDown={this._handleKeyDown}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label
                    for="auth-cat"
                    className="col-sm-3 col-form-label text-muted"
                  >
                    Section
                  </label>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <Select
                        value={this.state.approverpopupSection}
                        options={SectionTypeOptionList}
                        onChange={(value) => {
                          this.setState({ approverpopupSection: value });
                        }}
                        // onKeyDown={this._handleKeyDown}
                      />
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <Button
                    className="btn btn-light"
                    onClick={() => this.approversearchEmployeeClear()}
                  >
                    {" "}
                    Clear{" "}
                  </Button>
                  <Button
                    className="btn btn-primary-01 ml-3"
                    onClick={() => this.approversearchEmployee()}
                  >
                    {" "}
                    Search{" "}
                  </Button>
                </div>
              </section>
              <hr></hr>

              <section>
                <h2 className="fs-title"> </h2>
                <div className="table-responsive max-height-280">
                  <table className="table table-hover">
                    <thead className="thead-lightBlue">
                      <tr>
                        <th scope="col"> Action </th>
                        <th scope="col"> Employee No </th>
                        <th scope="col"> User Name </th>
                        <th scope="col"> Account </th>
                        <th scope="col"> Email </th>
                        <th scope="col"> Section </th>
                        <th scope="col"> Section Name </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.approverStaffDetailslistArray?.map(
                        (staff) => (
                          <tr
                            onClick={() =>
                              this.approverGetStaffDetails(
                                staff.employeeId,
                                staff.name,
                                staff.section,
                                staff.sectionName,
                                staff.department,
                                staff.division,
                                staff.designation
                              )
                            }
                            className="cursor-pointer"
                          >
                            <td>
                              {" "}
                              <p>
                                {" "}
                                <span className="material-icons-outlined select-employee-icon">
                                  {" "}
                                  how_to_reg{" "}
                                </span>{" "}
                              </p>{" "}
                            </td>
                            <td> {staff.employeeId} </td>
                            <td> {staff.name} </td>
                            <td> ({staff.account}) </td>
                            <td> {staff.email} </td>
                            <td> {staff.section} </td>
                            <td> {staff.sectionName} </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                  {(() => {
                    if (
                      this.state.approverStaffDetailslistArray.length <= 0 &&
                      this.state.approverStaffDetailslistArraySpin === "none"
                    ) {
                      return <p className="text-center">No record found.</p>; //safik
                    }
                  })()}
                  <p className="text-center">
                    <Spinner
                      animation="border"
                      variant="primary"
                      style={{
                        display: this.state.approverStaffDetailslistArraySpin,
                      }}
                      className="text-center"
                    />
                  </p>
                </div>
              </section>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-light"
                onClick={() => this.approverHideFirstStaffPopup()}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal show={this.state.formGetEmployeeFirstShow} size="xl">
            <Modal.Header>Employee Look Up</Modal.Header>
            <Modal.Body>
              <section className="p-3">
                <div className="form-group row mb-1">
                  <label
                    for="auth-name"
                    className="col-sm-3 col-form-label text-muted"
                  >
                    Employee Id
                  </label>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <input
                        type="number"
                        className="form-control"
                        name="formPopupEmployeeId"
                        value={this.state.formPopupEmployeeId}
                        onChange={this.handleChange}
                        onKeyDown={this._handleKeyDown}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label
                    for="auth-name"
                    className="col-sm-3 col-form-label text-muted"
                  >
                    Employee Name
                  </label>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="formPopupEmployeeName"
                        value={this.state.formPopupEmployeeName}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label
                    for="auth-cat"
                    className="col-sm-3 col-form-label text-muted"
                  >
                    Section
                  </label>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <Select
                        value={this.state.formPopupSection}
                        options={SectionTypeOptionList}
                        onChange={(value) => {
                          this.setState({ formPopupSection: value });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <Button
                    className="btn btn-light"
                    onClick={() => this.formSearchEmployeeClear()}
                  >
                    {" "}
                    Clear{" "}
                  </Button>
                  <Button
                    className="btn btn-primary-01 ml-3"
                    onClick={this.formSearchEmployee}
                  >
                    {" "}
                    Search{" "}
                  </Button>
                </div>
              </section>
              <hr></hr>

              <section>
                <h2 className="fs-title"> </h2>
                <div className="table-responsive max-height-280">
                  <table className="table table-hover">
                    <thead className="thead-lightBlue">
                      <tr>
                        <th scope="col"> Action </th>
                        <th scope="col"> Employee No </th>
                        <th scope="col"> User Name </th>
                        <th scope="col"> Account </th>
                        <th scope="col"> Email </th>
                        <th scope="col"> Section </th>
                        <th scope="col"> Section Name </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.formStaffDetailslistArray?.map((staff) => (
                        <tr
                          className="cursor-pointer"
                          onClick={() =>
                            this.formGetStaffDetails(
                              staff.employeeId,
                              staff.name,
                              staff.section,
                              staff.sectionName,
                              staff.department,
                              staff.division,
                              staff.designation
                            )
                          }
                        >
                          <td>
                            {" "}
                            <p>
                              {" "}
                              <span className="material-icons-outlined select-employee-icon">
                                {" "}
                                how_to_reg{" "}
                              </span>{" "}
                            </p>{" "}
                          </td>
                          <td> {staff.employeeId} </td>
                          <td> {staff.name} </td>
                          <td> ({staff.account}) </td>
                          <td> {staff.email} </td>
                          <td> {staff.section} </td>
                          <td> {staff.sectionName} </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {(() => {
                    if (
                      this.state.formStaffDetailslistArray.length <= 0 &&
                      this.state.formStaffDetailslistArraySpin === "none"
                    ) {
                      return <p className="text-center">No record found.</p>;
                    }
                  })()}
                  <p className="text-center">
                    <Spinner
                      animation="border"
                      variant="primary"
                      style={{
                        display: this.state.formStaffDetailslistArraySpin,
                      }}
                      className="text-center"
                    />
                  </p>
                </div>
              </section>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-light"
                onClick={() => this.formHideFirstStaffPopup()}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal show={this.state.attachmentdeletePopup}>
            <Modal.Header>Delete Confirmation</Modal.Header>
            <Modal.Body>
              <div className="alert alert-danger" role="alert">
                Are you sure you want to delete?
              </div>
              <hr></hr>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={this.cancelattachmentDelete}
                >
                  {" "}
                  No{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={this.confirmattachmentDelete}
                >
                  {" "}
                  Yes{" "}
                </Button>
              </div>
            </Modal.Body>
          </Modal>
          <Modal show={this.state.editAttachments} size="lg">
            <Modal.Header>Edit</Modal.Header>
            <Modal.Body>
              <section className="p-3">
                <div className="form-group row mb-1">
                  <label
                    for="auth-name"
                    className="col-sm-3 col-form-label text-muted"
                  >
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="editAttachments_Remarks"
                        defaultValue={this.state.editAttachments_Remarks}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <Button
                    className="btn btn-light"
                    onClick={() => this.editAttachmentsHide()}
                  >
                    {" "}
                    Cancel{" "}
                  </Button>
                  <Button
                    className="btn btn-primary-01 ml-3"
                    onClick={this.UpdateAttachments}
                  >
                    {" "}
                    Update{" "}
                  </Button>
                </div>
              </section>
            </Modal.Body>
          </Modal>
          <ul id="progressbar">
            <li
              id="req-info"
              className={
                (this.state.stepbarballon === 1 ? "active" : "") +
                (this.state.stepbarballon > 1 ? "selectedBar" : "")
              }
              onClick={() => this.progressSetps(1)}
            >
              <strong
                className={
                  (this.state.stepbarballon === 1 ? "active-text" : "") +
                  (this.state.stepbarballon > 1 ? "selected-text" : "")
                }
              >
                Request Details
              </strong>
            </li>
            <li
              id="auth-career"
              className={
                (this.state.stepbarballon === 2 ? "active" : "") +
                (this.state.stepbarballon > 2 ? "selectedBar" : "")
              }
              onClick={() => this.progressSetps(2)}
            >
              <strong
                className={
                  (this.state.stepbarballon === 2 ? "active-text" : "") +
                  (this.state.stepbarballon > 2 ? "selected-text" : "")
                }
              >
                Approval Flow{" "}
              </strong>
            </li>
          </ul>
          {this.state.stepbarballon === 1 && (
            <>
              <div className="mt-2">
                <h6 style={{ backgroundColor: "#e9e7e7", padding: "1%" }}>
                  Requester Information
                  <i
                    className="fa fa-angle-down text-muted"
                    style={{
                      float: "right",
                      fontSize: "24px",
                    }}
                  ></i>
                </h6>
              </div>
              <Collapse isOpen={true}>
                <Card>
                  <CardBody>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group row">
                          <label
                            for=""
                            className="col-sm-2 col-form-label text-muted"
                          >
                            <span style={{ display: "flex" }}>
                              {" "}
                              Staff No / Name{" "}
                              <p style={{ color: "red", marginLeft: 5 }}>
                                *
                              </p>{" "}
                            </span>
                          </label>
                          <div className="col-sm-4">
                            <div className="input-group mb-2 mr-sm-2">
                              <input
                                type="text"
                                className="form-control"
                                id=""
                                placeholder=""
                                readOnly={true}
                                value={this.state.RequesterDisplayName}
                                onClick={this.showFirstStaffPopup}
                              />
                              <div
                                className="input-group-prepend"
                                onClick={this.showFirstStaffPopup}
                              >
                                <div className="input-group-text">
                                  <i className="fa fa-search text-muted"> </i>
                                </div>
                              </div>
                              <div
                                className="input-group-prepend ml-3"
                                style={{
                                  display: this.state.canStafNamePopover,
                                }}
                              >
                                <button
                                  id="PopoverLegacy"
                                  className="input-group-text"
                                  type="button"
                                  data-toggle="popover"
                                  data-placement="bottom"
                                >
                                  <i className="fa fa-info text-muted"> </i>
                                </button>
                              </div>
                            </div>
                            {this.validator1.message(
                              "Staff No / Name",
                              this.state.RequesterDisplayName,
                              "required"
                            )}
                            <UncontrolledPopover
                              trigger="legacy"
                              placement="bottom"
                              target="PopoverLegacy"
                            >
                              <PopoverHeader></PopoverHeader>
                              <PopoverBody>
                                <div class="pop">
                                  <div class="row">
                                    <div class="col-xs-4 col-md-4">Section</div>
                                    <div class="col-xs-8 col-md-8">
                                      : {this.state.RequesterSection}
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-xs-4 col-md-4">
                                      Department
                                    </div>
                                    <div class="col-xs-8 col-md-8">
                                      : {this.state.RequesterDepartment}
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-xs-4 col-md-4">
                                      Division
                                    </div>
                                    <div class="col-xs-8 col-md-8">
                                      : {this.state.RequesterDivision}
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-xs-4 col-md-4">
                                      Designation
                                    </div>
                                    <div class="col-xs-8 col-md-8">
                                      : {this.state.RequesterDesignation}
                                    </div>
                                  </div>
                                </div>
                              </PopoverBody>
                            </UncontrolledPopover>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Collapse>
              <div
                className="mt-2"
                onClick={() =>
                  this.setState({ ...this.state, step2: !this.state.step2 })
                }
              >
                <h6 style={{ backgroundColor: "#e9e7e7", padding: "1%" }}>
                  Request Item Details
                  <i
                    className="fa fa-angle-down text-muted"
                    style={{
                      float: "right",
                      fontSize: "24px",
                    }}
                  ></i>
                </h6>
              </div>
              <Collapse isOpen={this.state.step2}>
                <Card>
                  <CardBody>
                    <div className="row">
                      <div className="col-md-12">
                        <section className="p-2">
                          <div className="form-group row mb-1">
                            <label
                              for="auth-cat"
                              className="col-sm-2 col-form-label text-muted"
                            >
                              <span style={{ display: "flex" }}>
                                {" "}
                                eDoc Type
                                <p style={{ color: "red", marginLeft: 5 }}>
                                  *
                                </p>{" "}
                              </span>
                            </label>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <Select
                                  options={RequestTypeOptionList}
                                  onChange={(value) =>
                                    this.handleSelectFormFields(
                                      value,
                                      "requestTypeOptionList"
                                    )
                                  }
                                  value={this.state.popupSection}
                                />
                              </div>
                            </div>
                          </div>
                          {!this.state.popupSection &&
                            this.state.errorStatus && (
                              <div className="form-group row mb-1 ">
                                <label
                                  for="auth-cat"
                                  className="col-sm-2 col-form-label text-muted"
                                >
                                  {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                </label>
                                {!this.state.popupSection &&
                                this.state.errorStatus ? (
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <p style={{ fontSize: 13, color: "red" }}>
                                        This field is required *
                                      </p>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            )}
                        </section>
                      </div>
                      {this.state.popupSection?.value == "HRIS" && (
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted"
                              >
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Action Category
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>
                              <div className="col-sm-6">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="Single"
                                    value="Single"
                                    checked={
                                      this.state.ActionCatrgory === "Single"
                                        ? "checked"
                                        : ""
                                    }
                                    onChange={this.handleChange}
                                  />
                                  <label
                                    className="form-check-label text-muted"
                                    for="inlineRadio1"
                                  >
                                    {" "}
                                    Single{" "}
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="Group"
                                    value="Group"
                                    checked={
                                      this.state.ActionCatrgory === "Group"
                                        ? "checked"
                                        : ""
                                    }
                                    onChange={this.handleChange}
                                  />
                                  <label
                                    className="form-check-label text-muted"
                                    for="inlineRadio2"
                                  >
                                    {" "}
                                    Group{" "}
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="None"
                                    value="None"
                                    checked={
                                      this.state.ActionCatrgory === "None"
                                        ? "checked"
                                        : ""
                                    }
                                    onChange={this.handleChange}
                                  />
                                  <label
                                    className="form-check-label text-muted"
                                    for="inlineRadio2"
                                  >
                                    {" "}
                                    None{" "}
                                  </label>
                                </div>
                              </div>
                            </div>
                            {this.state.popupSection?.id &&
                              !this.state.ActionCatrgory &&
                              this.state.errorStatus && (
                                <div className="form-group row mb-1 ">
                                  <label
                                    for="auth-cat"
                                    className="col-sm-2 col-form-label text-muted"
                                  >
                                    {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                  </label>
                                  {this.state.popupSection?.id &&
                                  !this.state.ActionCatrgory &&
                                  this.state.errorStatus ? (
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <p
                                          style={{
                                            fontSize: 13,
                                            color: "red",
                                          }}
                                        >
                                          This field is required *
                                        </p>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              )}
                          </section>
                        </div>
                      )}
                      {this.state.popupSection?.value == "HRIS" && (
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted"
                              >
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Action Type
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <Select
                                    options={actionTypeOptionList}
                                    onChange={(value) =>
                                      this.handleSelectFormFields(
                                        value,
                                        "actionTypeOptionList"
                                      )
                                    }
                                    value={this.state.actionType}
                                    // onKeyDown={this._handleKeyDown}
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.popupSection?.id &&
                              !this.state.actionType &&
                              this.state.errorStatus && (
                                <div className="form-group row mb-1 ">
                                  <label
                                    for="auth-cat"
                                    className="col-sm-2 col-form-label text-muted"
                                  >
                                    {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                  </label>
                                  {this.state.popupSection?.id &&
                                  !this.state.actionType &&
                                  this.state.errorStatus ? (
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <p
                                          style={{
                                            fontSize: 13,
                                            color: "red",
                                          }}
                                        >
                                          This field is required *
                                        </p>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              )}
                          </section>
                        </div>
                      )}
                      {this.state.popupSection?.value == "HRIS" &&
                        this.state.ActionCatrgory === "Single" && (
                          <div className="col-md-12">
                            <section className="p-2">
                              <div className="form-group row mb-1">
                                <label
                                  for="auth-cat"
                                  className="col-sm-2 col-form-label text-muted"
                                >
                                  <span style={{ display: "flex" }}>
                                    {" "}
                                    Company Code
                                    <p style={{ color: "red", marginLeft: 5 }}>
                                      *
                                    </p>{" "}
                                  </span>
                                </label>
                                <div className="col-sm-6">
                                  <div className="form-group">
                                    <Select
                                      options={companyOptionList}
                                      onChange={(value) =>
                                        this.handleSelectFormFields(
                                          value,
                                          "companyCode"
                                        )
                                      }
                                      value={this.state.companyCode}
                                      // onKeyDown={this._handleKeyDown}
                                    />
                                  </div>
                                </div>
                              </div>
                              {this.state.popupSection?.id &&
                                !this.state.companyCode &&
                                this.state.errorStatus && (
                                  <div className="form-group row mb-1 ">
                                    <label
                                      for="auth-cat"
                                      className="col-sm-2 col-form-label text-muted"
                                    >
                                      {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                    </label>
                                    {this.state.popupSection?.id &&
                                    !this.state.companyCode &&
                                    this.state.errorStatus ? (
                                      <div className="col-sm-6">
                                        <div className="form-group">
                                          <p
                                            style={{
                                              fontSize: 13,
                                              color: "red",
                                            }}
                                          >
                                            This field is required *
                                          </p>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                )}
                            </section>
                          </div>
                        )}
                      {this.state.popupSection?.value == "HRIS" &&
                        this.state.ActionCatrgory === "Single" && (
                          <div className="col-md-12">
                            <section className="p-2">
                              <div className="form-group row mb-1">
                                <label
                                  for="auth-cat"
                                  className="col-sm-2 col-form-label text-muted"
                                >
                                  <span style={{ display: "flex" }}>
                                    {" "}
                                    Division Code
                                    <p style={{ color: "red", marginLeft: 5 }}>
                                      *
                                    </p>{" "}
                                  </span>
                                </label>
                                <div className="col-sm-6">
                                  <div className="form-group">
                                    <Select
                                      options={divisionOptionList}
                                      onChange={(value) =>
                                        this.handleSelectFormFields(
                                          value,
                                          "divisionCode"
                                        )
                                      }
                                      value={this.state.divisionCode}
                                    />
                                  </div>
                                </div>
                              </div>
                              {this.state.popupSection?.id &&
                                !this.state.divisionCode &&
                                this.state.errorStatus && (
                                  <div className="form-group row mb-1 ">
                                    <label
                                      for="auth-cat"
                                      className="col-sm-2 col-form-label text-muted"
                                    >
                                      {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                    </label>
                                    {this.state.popupSection?.id &&
                                    !this.state.divisionCode &&
                                    this.state.errorStatus ? (
                                      <div className="col-sm-6">
                                        <div className="form-group">
                                          <p
                                            style={{
                                              fontSize: 13,
                                              color: "red",
                                            }}
                                          >
                                            This field is required *
                                          </p>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                )}
                            </section>
                          </div>
                        )}

                      {this.state.popupSection?.value == "HRIS" &&
                        this.state.ActionCatrgory == "None" &&
                        this.state.actionType?.value == "Others" && (
                          <div className="col-md-12">
                            <section className="p-2">
                              <div className="form-group row mb-1">
                                <label
                                  for="auth-cat"
                                  className="col-sm-2 col-form-label text-muted"
                                >
                                  {/* <span style={{ display: 'flex' }}>
                                  {' '}
                                  Action Type
                                  <p style={{ color: 'red', marginLeft: 5 }}>
                                    *
                                  </p>{' '}
                                </span> */}
                                </label>
                                <div className="col-sm-6">
                                  <div className="form-group">
                                    <textarea
                                      className="form-control"
                                      id=""
                                      rows="4"
                                      name="Others"
                                      value={this.state.addInfo}
                                      onChange={this.handleChange}
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        )}
                      {this.state.popupSection?.value == "HRIS" &&
                      this.state.ActionCatrgory === "Single" &&
                      this.state.actionType?.value == "New Hiring" ? (
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted"
                              >
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Employee ID / Name
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <Input
                                    type="text"
                                    value={this.state.employeeID}
                                    onChange={(e) =>
                                      this.handleSelectFormFields(
                                        e.target.value,
                                        "employeeID"
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.popupSection?.id &&
                              !this.state.employeeID &&
                              this.state.errorStatus && (
                                <div className="form-group row mb-1 ">
                                  <label
                                    for="auth-cat"
                                    className="col-sm-2 col-form-label text-muted"
                                  >
                                    {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                  </label>
                                  {this.state.popupSection?.id &&
                                  !this.state.employeeID &&
                                  this.state.errorStatus ? (
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <p
                                          style={{
                                            fontSize: 13,
                                            color: "red",
                                          }}
                                        >
                                          This field is required *
                                        </p>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              )}
                          </section>
                        </div>
                      ) : (
                        <div className="col-md-12">
                          {this.state.popupSection?.value == "HRIS" &&
                            this.state.ActionCatrgory === "Single" &&
                            this.state.actionType?.value != "New Hiring" && (
                              <div className="form-group row">
                                <label
                                  for=""
                                  className="col-sm-2 col-form-label text-muted"
                                >
                                  <span style={{ display: "flex" }}>
                                    {" "}
                                    Employee ID / Name{" "}
                                    <p style={{ color: "red", marginLeft: 5 }}>
                                      *
                                    </p>{" "}
                                  </span>
                                </label>
                                <div className="col-sm-4">
                                  <div className="input-group mb-2 mr-sm-2">
                                    <input
                                      type="text"
                                      className="form-control"
                                      id=""
                                      placeholder=""
                                      readOnly={true}
                                      value={
                                        this.state.formRequesterDisplayName
                                      }
                                      onClick={this.formShowFirstStaffPopup}
                                    />
                                    <div
                                      className="input-group-prepend"
                                      onClick={this.formShowFirstStaffPopup}
                                    >
                                      <div className="input-group-text">
                                        <i className="fa fa-search text-muted">
                                          {" "}
                                        </i>
                                      </div>
                                    </div>
                                    <div
                                      className="input-group-prepend ml-3"
                                      style={{
                                        display:
                                          this.state.formCanStafNamePopover,
                                      }}
                                    >
                                      <button
                                        id="PopoverLegacy"
                                        className="input-group-text"
                                        type="button"
                                        data-toggle="popover"
                                        data-placement="bottom"
                                      >
                                        <i className="fa fa-info text-muted">
                                          {" "}
                                        </i>
                                      </button>
                                    </div>
                                  </div>

                                  <UncontrolledPopover
                                    trigger="legacy"
                                    placement="bottom"
                                    target="PopoverLegacy"
                                  >
                                    <PopoverHeader></PopoverHeader>
                                    <PopoverBody>
                                      <div class="pop">
                                        <div class="row">
                                          <div class="col-xs-4 col-md-4">
                                            Section
                                          </div>
                                          <div class="col-xs-8 col-md-8">
                                            : {this.state.formRequesterSection}
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-xs-4 col-md-4">
                                            Department
                                          </div>
                                          <div class="col-xs-8 col-md-8">
                                            :{" "}
                                            {this.state.formRequesterDepartment}
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-xs-4 col-md-4">
                                            Division
                                          </div>
                                          <div class="col-xs-8 col-md-8">
                                            : {this.state.formRequesterDivision}
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-xs-4 col-md-4">
                                            Designation
                                          </div>
                                          <div class="col-xs-8 col-md-8">
                                            :{" "}
                                            {
                                              this.state
                                                .formRequesterDesignation
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </PopoverBody>
                                  </UncontrolledPopover>
                                </div>
                              </div>
                            )}
                        </div>
                      )}
                      {this.state.popupSection?.id &&
                        this.state.actionType?.value == "Re-Entry" &&
                        !this.state.formRequesterId &&
                        this.state.errorStatus && (
                          <div
                            className="form-group row mb-1"
                            style={{ display: "contents" }}
                          >
                            <label
                              for="auth-cat"
                              className="col-sm-2 col-form-label text-muted"
                            >
                              {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                            </label>
                            {this.state.popupSection?.id &&
                            this.state.actionType?.value == "Re-Entry" &&
                            !this.state.formRequesterId &&
                            this.state.errorStatus ? (
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <p style={{ fontSize: 13, color: "red" }}>
                                    This field is required *
                                  </p>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        )}
                      {this.state.popupSection?.value == "HRIS" &&
                        this.state.ActionCatrgory === "Single" && (
                          <div className="col-md-12">
                            <section className="p-2">
                              <div className="form-group row mb-1">
                                <label
                                  for="auth-cat"
                                  className="col-sm-2 col-form-label text-muted"
                                >
                                  <span style={{ display: "flex" }}>
                                    {" "}
                                    Position ID
                                    <p style={{ color: "red", marginLeft: 5 }}>
                                      *
                                    </p>{" "}
                                  </span>
                                </label>
                                <div className="col-sm-6">
                                  <div className="form-group">
                                    <Input
                                      value={this.state.positionID}
                                      onChange={(e) =>
                                        this.handleSelectFormFields(
                                          e.target.value,
                                          "positionID"
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              {this.state.popupSection?.id &&
                                !this.state.positionID &&
                                this.state.errorStatus && (
                                  <div className="form-group row mb-1 ">
                                    <label
                                      for="auth-cat"
                                      className="col-sm-2 col-form-label text-muted"
                                    >
                                      {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                    </label>
                                    {this.state.popupSection?.id &&
                                    !this.state.positionID &&
                                    this.state.errorStatus ? (
                                      <div className="col-sm-6">
                                        <div className="form-group">
                                          <p
                                            style={{
                                              fontSize: 13,
                                              color: "red",
                                            }}
                                          >
                                            This field is required *
                                          </p>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                )}
                            </section>
                          </div>
                        )}
                      {this.state.popupSection?.value == "HRIS" &&
                        this.state.ActionCatrgory === "Single" && (
                          <div className="col-md-12">
                            <section className="p-2">
                              <div className="form-group row mb-1">
                                <label
                                  for="auth-cat"
                                  className="col-sm-2 col-form-label text-muted"
                                >
                                  <span style={{ display: "flex" }}>
                                    {" "}
                                    Salary Grade
                                    <p style={{ color: "red", marginLeft: 5 }}>
                                      *
                                    </p>{" "}
                                  </span>
                                </label>
                                <div className="col-sm-6">
                                  <div className="form-group">
                                    <Input
                                      value={this.state.salaryGrade}
                                      onChange={(e) =>
                                        this.handleSelectFormFields(
                                          e.target.value,
                                          "salaryGrade"
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              {this.state.popupSection?.id &&
                                !this.state.salaryGrade &&
                                this.state.errorStatus && (
                                  <div className="form-group row mb-1 ">
                                    <label
                                      for="auth-cat"
                                      className="col-sm-2 col-form-label text-muted"
                                    >
                                      {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                    </label>
                                    {this.state.popupSection?.id &&
                                    !this.state.salaryGrade &&
                                    this.state.errorStatus ? (
                                      <div className="col-sm-6">
                                        <div className="form-group">
                                          <p
                                            style={{
                                              fontSize: 13,
                                              color: "red",
                                            }}
                                          >
                                            This field is required *
                                          </p>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                )}
                            </section>
                          </div>
                        )}
                      {this.state.popupSection?.value == "HRIS" &&
                        this.state.ActionCatrgory === "Single" && (
                          <div className="col-md-12">
                            <section className="p-2">
                              <div className="form-group row mb-1">
                                <label
                                  for="auth-cat"
                                  className="col-sm-2 col-form-label text-muted"
                                >
                                  <span style={{ display: "flex" }}>
                                    {" "}
                                    Working Group
                                    <p style={{ color: "red", marginLeft: 5 }}>
                                      *
                                    </p>{" "}
                                  </span>
                                </label>
                                <div className="col-sm-6">
                                  <div className="form-group">
                                    <Input
                                      value={this.state.workingGroup}
                                      onChange={(e) =>
                                        this.handleSelectFormFields(
                                          e.target.value,
                                          "workingGroup"
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              {this.state.popupSection?.id &&
                                !this.state.workingGroup &&
                                this.state.errorStatus && (
                                  <div className="form-group row mb-1 ">
                                    <label
                                      for="auth-cat"
                                      className="col-sm-2 col-form-label text-muted"
                                    >
                                      {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                    </label>
                                    {this.state.popupSection?.id &&
                                    !this.state.workingGroup &&
                                    this.state.errorStatus ? (
                                      <div className="col-sm-6">
                                        <div className="form-group">
                                          <p
                                            style={{
                                              fontSize: 13,
                                              color: "red",
                                            }}
                                          >
                                            This field is required *
                                          </p>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                )}
                            </section>
                          </div>
                        )}
                      {this.state.popupSection?.value == "HRIS" &&
                        this.state.ActionCatrgory === "Single" && (
                          <div className="col-md-12">
                            <section className="p-2">
                              <div className="form-group row mb-1">
                                <label
                                  for="auth-cat"
                                  className="col-sm-2 col-form-label text-muted"
                                >
                                  <span style={{ display: "flex" }}>
                                    {" "}
                                    Additional Information
                                    <p style={{ color: "red", marginLeft: 5 }}>
                                      *
                                    </p>{" "}
                                  </span>
                                </label>
                                <div className="col-sm-6">
                                  <div className="form-group">
                                    <Input
                                      value={this.state.addInfo}
                                      onChange={(e) =>
                                        this.handleSelectFormFields(
                                          e.target.value,
                                          "addInfo"
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              {this.state.popupSection?.id &&
                                !this.state.addInfo &&
                                this.state.errorStatus && (
                                  <div className="form-group row mb-1 ">
                                    <label
                                      for="auth-cat"
                                      className="col-sm-2 col-form-label text-muted"
                                    >
                                      {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                    </label>
                                    {this.state.popupSection?.id &&
                                    !this.state.addInfo &&
                                    this.state.errorStatus ? (
                                      <div className="col-sm-6">
                                        <div className="form-group">
                                          <p
                                            style={{
                                              fontSize: 13,
                                              color: "red",
                                            }}
                                          >
                                            This field is required *
                                          </p>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                )}
                            </section>
                          </div>
                        )}
                      {this.state.popupSection?.value == "HRIS" &&
                        this.state.ActionCatrgory === "Single" && (
                          <div className="col-md-12">
                            <section className="p-2">
                              <div className="form-group row mb-1">
                                <label
                                  for="auth-cat"
                                  className="col-sm-2 col-form-label text-muted"
                                >
                                  <span style={{ display: "flex" }}>
                                    {" "}
                                    Start Date
                                    <p style={{ color: "red", marginLeft: 5 }}>
                                      *
                                    </p>{" "}
                                  </span>
                                </label>
                                <div className="col-sm-3">
                                  <div className="form-group">
                                    <DatePicker
                                      format="dd-MM-y"
                                      onKeyDown={(e) => {
                                        e.preventDefault();
                                      }}
                                      clearIcon={null}
                                      onChange={this.startDate}
                                      className="date-picker-style form-control"
                                      value={new Date(this.state.startDate)}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="form-group row mb-1">
                                <label
                                  for="auth-cat"
                                  className="col-sm-2 col-form-label text-muted"
                                >
                                  <span style={{ display: "flex" }}>
                                    {" "}
                                    End Date
                                    <p style={{ color: "red", marginLeft: 5 }}>
                                      *
                                    </p>{" "}
                                  </span>
                                </label>

                                <div className="col-sm-3">
                                  <div className="form-group">
                                    <DatePicker
                                      format="dd-MM-y"
                                      onKeyDown={(e) => {
                                        e.preventDefault();
                                      }}
                                      clearIcon={null}
                                      onChange={this.endDate}
                                      className="date-picker-style form-control"
                                      value={new Date(this.state.endDate)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        )}
                      {this.state.popupSection?.value?.includes(
                        "Employee Clearance"
                      ) && (
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted"
                              >
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Type of Exit
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <Select
                                    options={exitOptionList}
                                    onChange={(value) =>
                                      this.handleSelectFormFields(
                                        value,
                                        "typeOfExit"
                                      )
                                    }
                                    value={this.state.typeOfExit}
                                    onKeyDown={this._handleKeyDown}
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.popupSection?.id &&
                              !this.state.typeOfExit &&
                              this.state.errorStatus && (
                                <div className="form-group row mb-1 ">
                                  <label
                                    for="auth-cat"
                                    className="col-sm-2 col-form-label text-muted"
                                  >
                                    {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                  </label>
                                  {this.state.popupSection?.id &&
                                  !this.state.typeOfExit &&
                                  this.state.errorStatus ? (
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <p
                                          style={{
                                            fontSize: 13,
                                            color: "red",
                                          }}
                                        >
                                          This field is required *
                                        </p>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              )}
                          </section>
                        </div>
                      )}

                      {this.state.popupSection?.value?.includes(
                        "Employee Clearance"
                      ) && (
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted"
                              >
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Date Joined
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>
                              <div className="col-sm-3">
                                <div className="form-group">
                                  <DatePicker
                                    format="dd-MM-y"
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                    }}
                                    clearIcon={null}
                                    onChange={this.joiningDate}
                                    className="date-picker-style form-control"
                                    value={new Date(this.state.joiningDate)}
                                    // value={
                                    //   this.state.popupSection?.value?.includes(
                                    //     "Employee Clearance"
                                    //   )
                                    //     ? new Date(this.state.dateJoin)
                                    //     : new Date(this.state.joiningDate)
                                    // }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted"
                              >
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Last Day of Service
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>

                              <div className="col-sm-3">
                                <div className="form-group">
                                  <DatePicker
                                    format="dd-MM-y"
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                    }}
                                    clearIcon={null}
                                    onChange={this.lastDate}
                                    className="date-picker-style form-control"
                                    value={new Date(this.state.lastDate)}
                                  />
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      )}
                      {this.state.popupSection?.value?.includes(
                        "Employee Clearance"
                      ) && (
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted"
                              >
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Phone Number
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <Input
                                    type="text"
                                    value={this.state.phoneNumber}
                                    onChange={(e) =>
                                      this.handleSelectFormFields(
                                        e.target.value,
                                        "phoneNumber"
                                      )
                                    }
                                    onKeyDown={this._handleKeyDown}
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.popupSection?.id &&
                              !this.state.phoneNumber &&
                              this.state.errorStatus && (
                                <div className="form-group row mb-1 ">
                                  <label
                                    for="auth-cat"
                                    className="col-sm-2 col-form-label text-muted"
                                  >
                                    {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                  </label>
                                  {this.state.popupSection?.id &&
                                  !this.state.phoneNumber &&
                                  this.state.errorStatus ? (
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <p
                                          style={{
                                            fontSize: 13,
                                            color: "red",
                                          }}
                                        >
                                          This field is required *
                                        </p>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              )}
                          </section>
                        </div>
                      )}
                    </div>

                    {this.state.popupSection?.value?.includes(
                      "Employee Clearance"
                    ) && (
                      <div className="row">
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-name"
                                className="col-sm-2 col-form-label text-muted"
                              >
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Address
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <textarea
                                    className="form-control"
                                    id=""
                                    rows="3"
                                    name="address"
                                    value={this.state.address}
                                    onChange={(e) =>
                                      this.handleSelectFormFields(
                                        e.target.value,
                                        "address"
                                      )
                                    }
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                            {this.state.popupSection?.id &&
                              !this.state.address &&
                              this.state.errorStatus && (
                                <div className="form-group row mb-1 ">
                                  <label
                                    for="auth-cat"
                                    className="col-sm-2 col-form-label text-muted"
                                  >
                                    {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                  </label>
                                  {this.state.popupSection?.id &&
                                  !this.state.address &&
                                  this.state.errorStatus ? (
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <p
                                          style={{
                                            fontSize: 13,
                                            color: "red",
                                          }}
                                        >
                                          This field is required *
                                        </p>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              )}
                          </section>
                        </div>
                      </div>
                    )}
                    {this.state.ActionCatrgory === "Single" && (
                      <div className="row">
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-name"
                                className="col-sm-2 col-form-label text-muted"
                              >
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Justification
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>

                              <div className="col-sm-6">
                                <div className="form-group">
                                  <ReactQuill
                                    value={this.state.createDescription}
                                    onChange={this.handleCheck}
                                    placeholder="Justification"
                                    name="description"
                                    style={{ height: "100px" }}
                                    modules={{
                                      toolbar: [
                                        ["bold", "italic", "underline"],
                                        [
                                          { list: "ordered" },
                                          { list: "bullet" },
                                        ],
                                      ],
                                    }}
                                  />
                                  {/* <textarea
                                    className="form-control"
                                    id=""
                                    placeholder="Justification"
                                    rows="4"
                                    name="description"
                                    value={this.state.createDescription}
                                    onChange={this.handleChange}></textarea> */}
                                </div>
                              </div>
                            </div>

                            <div className="form-group row mb-1">
                              <label className="col-sm-2 col-form-label text-muted"></label>
                              <div className="col-sm-6 text-right">
                                <div className="form-group">
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color:
                                        this.state.wordCount.count <=
                                        this.state.wordCount.intialValue
                                          ? "#6c757d"
                                          : "red",
                                      margin: 8,
                                    }}
                                  >
                                    {`${this.state.wordCount.count} / ${this.state.wordCount.intialValue}`}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="form-group row mb-1 ">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted"
                              ></label>
                              {!this.state.createDescription &&
                                this.state.errorStatus && (
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <p style={{ fontSize: 13, color: "red" }}>
                                        This field is required *
                                      </p>
                                    </div>
                                  </div>
                                )}
                            </div>

                            {/* {!this.state.createDescription &&
                              this.state.errorStatus && (
                                <div className="text-danger text-center">
                                  This field is required.
                                </div>
                              )} */}
                          </section>
                        </div>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Collapse>
              <div
                className="mt-2"
                onClick={() =>
                  this.state.popupSection?.id
                    ? this.setState({ ...this.state, step3: !this.state.step3 })
                    : toast.error("Please complete Request Item Details", {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                      })
                }
              >
                <h6 style={{ backgroundColor: "#e9e7e7", padding: "1%" }}>
                  Attachments
                  <i
                    className="fa fa-angle-down text-muted"
                    style={{
                      float: "right",
                      fontSize: "24px",
                    }}
                  ></i>
                </h6>
              </div>
              <Collapse
                isOpen={this.state.popupSection?.id && this.state.step3}
              >
                <Card>
                  <CardBody>
                    <div className="row">
                      <div className="col-md-12">
                        <section>
                          <h2 className="fs-title"> </h2>
                          <div>
                            <Dropzone onDrop={this.onDrop}>
                              {({ getRootProps, getInputProps }) => (
                                <div
                                  className="jumbotron text-center attachmentStyle"
                                  {...getRootProps()}
                                >
                                  <input {...getInputProps()} />
                                  Drag and drop files , Or click to select
                                  attachment files
                                </div>
                              )}
                            </Dropzone>
                          </div>
                          <div className="customized-table">
                            <div className="table-responsive max-height-280">
                              <table className="table table-hover">
                                <thead className="thead-lightBlue">
                                  <tr>
                                    <th scope="col"> #</th>
                                    <th scope="col">File name</th>
                                    {/* <th scope="col">File Type</th> */}
                                    <th scope="col">Remarks</th>
                                    <th scope="col">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.AttachmentslistArray.map(
                                    (loopdata, index) => (
                                      <tr>
                                        <td>{index + 1}</td>
                                        <td>{loopdata.filename}</td>
                                        {/* <td>{loopdata.filetype}</td> */}
                                        <td>{loopdata.remarks}</td>
                                        <td>
                                          <div
                                            className="action-icons"
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <i
                                              className="fa fa-pencil-square-o  text-muted cursor-pointer"
                                              aria-hidden="true"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              title="Edit"
                                              onClick={() =>
                                                this.editAttachmentsShow(
                                                  loopdata.sequenceNo,
                                                  loopdata.remarks
                                                )
                                              }
                                            ></i>
                                            <i
                                              className="fa fa-trash-o  text-muted cursor-pointer"
                                              aria-hidden="true"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              title="Delete"
                                              onClick={() =>
                                                this.deleteAttachment(
                                                  loopdata.sequenceNo
                                                )
                                              }
                                            ></i>
                                            
                                            <i
                                              aria-hidden="true"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              style={{ scale:" 0.9 "}}
                                              title="Need To Sign"
                                              onClick={() =>
                                                this.formNext(1, loopdata)
                                              }
                                              className="fa fa-file-o fa-md text-muted cursor-pointer"
                                            >
                                              <span className="text-muted " style={{
                                                fontWeight: "bold", padding: "0px 0px 0px 2px"
                                              }}>(Need To Sign)</span>
                                            </i>
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                              {(() => {
                                if (
                                  this.state.AttachmentslistArray.length <= 0
                                ) {
                                  return (
                                    <div>
                                      <p className="text-center">
                                        No record found.
                                      </p>
                                    </div>
                                  );
                                }
                              })()}
                              <p
                                className="text-center"
                                style={{
                                  display:
                                    this.state.AttachmentsLoader === "Yes"
                                      ? ""
                                      : "none",
                                }}
                              >
                                <Spinner
                                  animation="border"
                                  variant="primary"
                                  className="text-center"
                                />
                              </p>
                              {this.state.AttachmentslistArray.length <= 0 &&
                                this.state.errorStatus && (
                                  <div className="text-danger text-center">
                                    The Attachments is required.
                                  </div>
                                )}
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Collapse>
              <div
                className="mt-2"
                onClick={() =>
                  this.state.popupSection?.id
                    ? this.setState({ ...this.state, step4: !this.state.step4 })
                    : toast.error("Please complete Request Item Details", {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                      })
                }
              >
                <h6 style={{ backgroundColor: "#e9e7e7", padding: "1%" }}>
                  References
                  <i
                    className="fa fa-angle-down text-muted"
                    style={{
                      float: "right",
                      fontSize: "24px",
                    }}
                  ></i>
                </h6>
              </div>
              <Collapse
                isOpen={this.state.popupSection?.id && this.state.step4}
              >
                <Card>
                  <CardBody>
                    <div className="row">
                      <div className="col-md-12">
                        <section>
                          <h2 className="fs-title"> </h2>
                          <div className="customized-table">
                            <div className="table-responsive">
                              <table className="table table-hover">
                                <thead className="thead-lightBlue">
                                  <tr>
                                    <th scope="col">#</th>
                                    <th scope="col"> Reference Link </th>
                                    <th scope="col"> Remarks </th>
                                    <th scope="col" style={{ float: "right" }}>
                                      Action
                                      <button
                                        className="btn btn-success btn-sm ml-2"
                                        onClick={this.addReferences}
                                      >
                                        <span className="font-size-17">+</span>
                                      </button>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody
                                  style={{
                                    display:
                                      this.state.ReferencesLoader === "Yes"
                                        ? "none"
                                        : "",
                                  }}
                                >
                                  {this.state.ReferenceLinkslistArray.map(
                                    (data, index) => (
                                      <tr>
                                        <td>{index + 1}</td>
                                        <td>{data.reflink}</td>
                                        <td>{data.remarks}</td>
                                        <td>
                                          <div className="action-icons">
                                            <i
                                              className="fa fa-pencil-square-o text-muted"
                                              aria-hidden="true"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              title="Edit"
                                              onClick={() =>
                                                this.editReferencesShow(
                                                  data.sequenceNo,
                                                  data.reflink,
                                                  data.remarks
                                                )
                                              }
                                            ></i>
                                            <i
                                              className="fa fa-trash-o text-muted"
                                              aria-hidden="true"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              title="Delete"
                                              onClick={() =>
                                                this.deleteReferences(
                                                  data.sequenceNo
                                                )
                                              }
                                            ></i>
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  )}

                                  <tr
                                    style={{
                                      display: this.state.ReferencesAdd,
                                    }}
                                  >
                                    <td></td>
                                    <td>
                                      {" "}
                                      <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        name="editReferences_Reflink"
                                        value={
                                          this.state.editReferences_Reflink
                                        }
                                        onChange={this.handleChange}
                                      />{" "}
                                    </td>
                                    <td>
                                      {" "}
                                      <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Enter remarks"
                                        name="editReferences_Remarks"
                                        value={
                                          this.state.editReferences_Remarks
                                        }
                                        onChange={this.handleChange}
                                      />{" "}
                                    </td>
                                    <td>
                                      <div className="btn-group">
                                        <button
                                          className="btn btn-default btn-md"
                                          type="button"
                                          onClick={this.References_Save}
                                        >
                                          {" "}
                                          <i
                                            className="fa fa-floppy-o text-muted"
                                            aria-hidden="true"
                                          ></i>{" "}
                                          Save{" "}
                                        </button>
                                        <button
                                          className="btn btn-default btn-md ml-3"
                                          type="button"
                                          onClick={this.References_Cancel}
                                        >
                                          {" "}
                                          <i
                                            className="fa fa-trash-o text-muted"
                                            aria-hidden="true"
                                          ></i>{" "}
                                          Remove{" "}
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr
                                    style={{
                                      display: this.state.ReferencesAdd,
                                    }}
                                  >
                                    <td> </td>
                                    <td>
                                      {" "}
                                      {this.validator6.message(
                                        "Qty",
                                        this.state.References_Reflink,
                                        "required"
                                      )}{" "}
                                    </td>
                                    <td>
                                      {" "}
                                      {this.validator6.message(
                                        "Qty",
                                        this.state.References_Remarks,
                                        "required"
                                      )}{" "}
                                    </td>
                                    <td> </td>
                                  </tr>
                                </tbody>
                              </table>
                              {(() => {
                                if (
                                  this.state.ReferenceLinkslistArray.length <= 0
                                ) {
                                  return (
                                    <div
                                      style={{
                                        display:
                                          this.state.ReferencesAdd === "none"
                                            ? ""
                                            : "none",
                                      }}
                                    >
                                      <p className="text-center">
                                        No record found.
                                      </p>
                                    </div>
                                  );
                                }
                              })()}
                              <p
                                className="text-center"
                                style={{
                                  display:
                                    this.state.ReferencesLoader === "Yes"
                                      ? ""
                                      : "none",
                                }}
                              >
                                <Spinner
                                  animation="border"
                                  variant="primary"
                                  className="text-center"
                                />
                              </p>
                              <div
                                className="text-danger text-center"
                                style={{
                                  display: this.state.showReferenceRequired,
                                }}
                              >
                                The References is required.
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Collapse>
              <div
                className="text-center text-sm-right"
                style={{ marginTop: "25px" }}
              >
                <button
                  className="btn btn-draft"
                  type="button"
                  onClick={() => this.saveDraft(1)}
                >
                  <i className="fa fa-pencil-square-o"> </i> Save As Draft
                </button>
                <button
                  className="btn btn-primary-01 ml-3 float-right float-sm-none"
                  type="button"
                  onClick={() => this.formNext(1)}
                >
                  <span> Next </span>
                  <i className="fa fa-angle-right"> </i>{" "}
                </button>
                {/* <button className="btn btn-outline-info float-left" type="button">
                <i className="fa fa-angle-left"> </i>{' '}
                 <span> Previous </span>
              </button> */}
              </div>
            </>
          )}
          {this.state.stepbarballon === 2 && (
            <>
              {" "}
              <h6>Approvers</h6>
              <div
                className="mt-2"
                // onClick={() =>
                //   this.setState({ ...this.state, step4: !this.state.step4 })
                // }
              >
                <h6 style={{ backgroundColor: "#e9e7e7", padding: "1%" }}>
                  Approver Information (Approver Routing must in Sequence)
                  <i
                    className="fa fa-angle-down text-muted"
                    style={{
                      float: "right",
                      fontSize: "24px",
                    }}
                  ></i>
                </h6>
              </div>
              <Collapse isOpen={true}>
                <Card>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card-body">
                        <section>
                          <h2 className="fs-title"> </h2>
                          <div className="customized-table">
                            <div className="table-responsive ">
                              <table className="table table-hover">
                                <thead className="thead-lightBlue">
                                  <tr>
                                    <th scope="col" className="text-nowrap">
                                      Sequence No
                                    </th>
                                    <th scope="col" className="text-nowrap">
                                      Approver Name
                                    </th>
                                    <th scope="col" className="text-nowrap">
                                      Section
                                    </th>

                                    {!this.state.popupSection?.value?.includes(
                                      "Employee Clearance"
                                    ) &&
                                      this.state.popupSection?.value !=
                                        "HRIS" && (
                                        <th
                                          scope="col"
                                          className="float-right text-nowrap"
                                        >
                                          Action
                                          <button
                                            className="btn btn-success btn-sm ml-2"
                                            onClick={this.addApproverReferences}
                                          >
                                            {" "}
                                            <span className="font-size-17">
                                              +
                                            </span>{" "}
                                          </button>
                                        </th>
                                      )}
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state?.workflowid?.map((dt, index) => (
                                    <tr className="cursor-pointer">
                                      <td className="text-nowrap">
                                        {" "}
                                        {this.state.approverEdit?.status &&
                                        this.state.approverEdit?.value ==
                                          index ? (
                                          <Input
                                            type="text"
                                            name="sequence_no"
                                            defaultValue={
                                              this.state.sequence_no
                                                ? this.state.sequence_no
                                                : dt.sequenceno
                                            }
                                            onChange={this.handleChange}
                                          />
                                        ) : (
                                          dt.sequenceno
                                        )}
                                      </td>
                                      {this.state.approverEdit.status &&
                                      this.state.approverEdit.value == index ? (
                                        <td className="text-nowrap">
                                          <div>
                                            <div className="input-group mb-2 mr-sm-2">
                                              <Input
                                                disabled={dt.isEdit == 0}
                                                type="text"
                                                className="form-control"
                                                id=""
                                                placeholder=""
                                                readOnly={true}
                                                value={
                                                  this.state
                                                    .approverRequesterName
                                                    ? this.state
                                                        .approverRequesterName
                                                    : dt.oriapprovername
                                                }
                                                onClick={
                                                  this
                                                    .approverShowFirstStaffPopup
                                                }
                                              />
                                              <div
                                                className="input-group-prepend"
                                                onClick={
                                                  this
                                                    .approverShowFirstStaffPopup
                                                }
                                              >
                                                {dt.isEdit != 0 && (
                                                  <div className="input-group-text">
                                                    <i className="fa fa-search text-muted">
                                                      {" "}
                                                    </i>
                                                  </div>
                                                )}
                                              </div>
                                              <div
                                                className="input-group-prepend ml-3"
                                                style={{
                                                  display:
                                                    this.state
                                                      .approverCanStafNamePopover,
                                                }}
                                              >
                                                <button
                                                  id="PopoverLegacy"
                                                  className="input-group-text"
                                                  type="button"
                                                  data-toggle="popover"
                                                  data-placement="bottom"
                                                >
                                                  <i className="fa fa-info text-muted">
                                                    {" "}
                                                  </i>
                                                </button>
                                              </div>
                                            </div>

                                            <UncontrolledPopover
                                              trigger="legacy"
                                              placement="bottom"
                                              target="PopoverLegacy"
                                            >
                                              <PopoverHeader></PopoverHeader>
                                              <PopoverBody>
                                                <div class="pop">
                                                  <div class="row">
                                                    <div class="col-xs-4 col-md-4">
                                                      Section
                                                    </div>
                                                    <div class="col-xs-8 col-md-8">
                                                      :{" "}
                                                      {
                                                        this.state
                                                          .approverRequesterSection
                                                      }
                                                    </div>
                                                  </div>
                                                  <div class="row">
                                                    <div class="col-xs-4 col-md-4">
                                                      Department
                                                    </div>
                                                    <div class="col-xs-8 col-md-8">
                                                      :{" "}
                                                      {
                                                        this.state
                                                          .approverRequesterDepartment
                                                      }
                                                    </div>
                                                  </div>
                                                  <div class="row">
                                                    <div class="col-xs-4 col-md-4">
                                                      Division
                                                    </div>
                                                    <div class="col-xs-8 col-md-8">
                                                      :{" "}
                                                      {
                                                        this.state
                                                          .approverRequesterDivision
                                                      }
                                                    </div>
                                                  </div>
                                                  <div class="row">
                                                    <div class="col-xs-4 col-md-4">
                                                      Designation
                                                    </div>
                                                    <div class="col-xs-8 col-md-8">
                                                      :{" "}
                                                      {
                                                        this.state
                                                          .approverRequesterDesignation
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                              </PopoverBody>
                                            </UncontrolledPopover>
                                          </div>
                                        </td>
                                      ) : (
                                        <td className="text-nowrap">
                                          {`${dt.oriapproverid} / ${dt.oriapprovername}`}
                                        </td>
                                      )}
                                      <td className="mt-3 text-nowrap">
                                        {dt?.section ? dt?.section : " - "}
                                      </td>

                                      <td
                                        style={{ textAlign: "end" }}
                                        className="text-nowrap"
                                      >
                                        {this.state.approverEdit.status &&
                                        this.state.approverEdit.value ==
                                          index ? (
                                          <div className="btn-group">
                                            <button
                                              className="btn btn-default btn-md"
                                              type="button"
                                              onClick={() =>
                                                this.approverReferences_Save(
                                                  dt,
                                                  "Update"
                                                )
                                              }
                                            >
                                              {" "}
                                              <i
                                                className="fa fa-floppy-o text-muted"
                                                aria-hidden="true"
                                              ></i>{" "}
                                              Save{" "}
                                            </button>
                                            <button
                                              className="btn btn-default btn-md ml-3"
                                              type="button"
                                              onClick={() =>
                                                this.approverReferences_Save(
                                                  dt,
                                                  "Delete"
                                                )
                                              }
                                            >
                                              {" "}
                                              <i
                                                className="fa fa-trash-o text-muted"
                                                aria-hidden="true"
                                              ></i>{" "}
                                              Remove{" "}
                                            </button>
                                          </div>
                                        ) : dt?.isEdit != 0 ? (
                                          <div className="btn-group">
                                            <button
                                              className="btn btn-default btn-md"
                                              type="button"
                                              onClick={() =>
                                                this.setState({
                                                  ...this.state,
                                                  approverEdit: {
                                                    status: true,
                                                    value: index,
                                                  },
                                                })
                                              }
                                            >
                                              Edit{" "}
                                            </button>
                                          </div>
                                        ) : null}
                                      </td>
                                    </tr>
                                  ))}
                                  <tr
                                    style={{
                                      display: this.state.ApproverReferencesAdd,
                                    }}
                                  >
                                    <td className="text-nowrap">
                                      {" "}
                                      <Input
                                        type="number"
                                        name="sequence_no"
                                        value={this.state.sequence_no}
                                        onChange={this.handleChange}
                                      />{" "}
                                      {this.state.errorStatus &&
                                        !this.state.sequence_no && (
                                          <p
                                            style={{
                                              fontSize: 12,
                                              color: "red",
                                            }}
                                          >
                                            This field is required
                                          </p>
                                        )}
                                    </td>
                                    <td
                                      style={{ display: "contents" }}
                                      className="text-nowrap"
                                    >
                                      <td>
                                        <div>
                                          <div className="input-group mb-2 mr-sm-2">
                                            <input
                                              type="text"
                                              className="form-control"
                                              id=""
                                              placeholder=""
                                              readOnly={true}
                                              value={
                                                this.state
                                                  .approverRequesterDisplayName
                                              }
                                              onClick={
                                                this.approverShowFirstStaffPopup
                                              }
                                            />

                                            <div
                                              className="input-group-prepend"
                                              onClick={
                                                this.approverShowFirstStaffPopup
                                              }
                                            >
                                              <div className="input-group-text">
                                                <i className="fa fa-search text-muted">
                                                  {" "}
                                                </i>
                                              </div>
                                            </div>
                                            <div
                                              className="input-group-prepend ml-3"
                                              style={{
                                                display:
                                                  this.state
                                                    .approverCanStafNamePopover,
                                              }}
                                            >
                                              <button
                                                id="PopoverLegacy"
                                                className="input-group-text"
                                                type="button"
                                                data-toggle="popover"
                                                data-placement="bottom"
                                              >
                                                <i className="fa fa-info text-muted">
                                                  {" "}
                                                </i>
                                              </button>
                                            </div>
                                            {this.state.errorStatus &&
                                              !this.state
                                                .approverRequesterId && (
                                                <p
                                                  style={{
                                                    fontSize: 12,
                                                    color: "red",
                                                  }}
                                                >
                                                  This field is required
                                                </p>
                                              )}
                                          </div>

                                          <UncontrolledPopover
                                            trigger="legacy"
                                            placement="bottom"
                                            target="PopoverLegacy"
                                          >
                                            <PopoverHeader></PopoverHeader>
                                            <PopoverBody>
                                              <div class="pop">
                                                <div class="row">
                                                  <div class="col-xs-4 col-md-4">
                                                    Section
                                                  </div>
                                                  <div class="col-xs-8 col-md-8">
                                                    :{" "}
                                                    {
                                                      this.state
                                                        .approverRequesterSection
                                                    }
                                                  </div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-xs-4 col-md-4">
                                                    Department
                                                  </div>
                                                  <div class="col-xs-8 col-md-8">
                                                    :{" "}
                                                    {
                                                      this.state
                                                        .approverRequesterDepartment
                                                    }
                                                  </div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-xs-4 col-md-4">
                                                    Division
                                                  </div>
                                                  <div class="col-xs-8 col-md-8">
                                                    :{" "}
                                                    {
                                                      this.state
                                                        .approverRequesterDivision
                                                    }
                                                  </div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-xs-4 col-md-4">
                                                    Designation
                                                  </div>
                                                  <div class="col-xs-8 col-md-8">
                                                    :{" "}
                                                    {
                                                      this.state
                                                        .approverRequesterDesignation
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                            </PopoverBody>
                                          </UncontrolledPopover>
                                        </div>
                                      </td>
                                    </td>
                                    <td className="text-nowrap">
                                      {" "}
                                      <input
                                        disabled
                                        className="form-control"
                                        name="editReferences_Remarks"
                                        value={
                                          this.state.approverRequesterSection
                                        }
                                        onChange={this.handleChange}
                                      />{" "}
                                    </td>
                                    <td className="text-nowrap">
                                      <div className="btn-group">
                                        <button
                                          className="btn btn-default btn-md"
                                          type="button"
                                          onClick={this.approverReferences_Save}
                                        >
                                          {" "}
                                          <i
                                            className="fa fa-floppy-o text-muted"
                                            aria-hidden="true"
                                          ></i>{" "}
                                          Save{" "}
                                        </button>
                                        <button
                                          className="btn btn-default btn-md ml-3"
                                          type="button"
                                          onClick={() =>
                                            this.setState({
                                              approverEdit: {
                                                status: false,
                                                value: "",
                                              },
                                              sequence_no: "",
                                              errorStatus: false,
                                              ApproverReferencesAdd: "none",
                                              ApproverShowReferenceRequired:
                                                "none",
                                              approverRequesterId: "",
                                              approverRequesterName: "",
                                              approverRequesterSection: "",
                                              approverRequesterSectionName: "",
                                              approverRequesterDepartment: "",
                                              approverRequesterDivision: "",
                                              approverRequesterDesignation: "",
                                              approverCanStafNamePopover:
                                                "flex",
                                              approverGetEmployeeFirstShow: "",
                                              approverRequesterDisplayName: "",
                                              approverpopupEmployeeId: "",
                                              approverpopupEmployeeName: "",
                                              approverpopupSection: 0,
                                              approverStaffDetailslistArray: [],
                                            })
                                          }
                                        >
                                          {" "}
                                          <i
                                            className="fa fa-trash-o text-muted"
                                            aria-hidden="true"
                                          ></i>{" "}
                                          Remove{" "}
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </Card>
              </Collapse>
              <div className="col-md-12 mt-2">
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <button
                    className="btn btn-outline-info float-left"
                    type="button"
                    onClick={() => this.formprevious(1)}
                  >
                    <i className="fa fa-angle-left"> </i>{" "}
                    <span> Previous </span>
                  </button>
                  <button
                    className="btn btn-primary-01 ml-3"
                    type="button"
                    onClick={this.cancelHandler}
                  >
                    <span> Cancel </span>
                  </button>
                  <button
                    className="btn btn-primary-01 ml-3"
                    type="button"
                    onClick={this.submitHandler}
                  >
                    Submit
                  </button>
                </div>
              </div>
              <div
                className="mt-3"
                // onClick={() =>
                //   this.setState({ ...this.state, step4: !this.state.step4 })
                // }
              >
                <h6 style={{ backgroundColor: "#e9e7e7", padding: "1%" }}>
                  Workflow History
                  <i
                    // className="fa fa-angle-down text-muted"
                    style={{
                      float: "right",
                      fontSize: "24px",
                    }}
                  ></i>
                </h6>
                <div className="card-body">
                  <h5 className="card-title text-center">No Records Found</h5>
                </div>
              </div>
            </>
          )}
        </LoadingOverlay>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
    Referenceno: state.Referenceno,
  };
};

export default connect(mapStateToProps)(CreateRequest);

// onClick={() => {
//   if (
//     !loopdata?.filePath &&
//     !loopdata?.fileRecord
//   ) {
//     toast.info(
//       "The specified file or path not found",
//       {
//         position:
//           toast.POSITION
//             .TOP_CENTER,
//         autoClose: 2000,
//       }
//     );
//     return;
//   }

//   window.open(
//     `/signature?file=${encodeURIComponent(
//       loopdata.filePath ?? "null"
//     )}&sequenceNo=${encodeURIComponent(
//       loopdata.sequenceNo ?? ""
//     )}&referenceNo=${encodeURIComponent(
//       loopdata.referenceNo ?? ""
//     )}&filename=${encodeURIComponent(
//       loopdata.filename ?? ""
//     )}&location=${encodeURIComponent(
//       location.pathname ?? ""
//     )}`,
//     "_self"
//   );
// }}
